import React, { useState, useEffect, useCallback, useRef } from 'react';
import MapaExpo from './MapaExpo';
import ZonaStands from './ZonaStands';
import { STORAGE_KEYS, storage } from './utils/storage';
import { API_BASE } from './config/api';

const API = API_BASE;   // direccion del backend: config/api.js (fuente unica)
const PP = "'Poppins', sans-serif";

const C = {
  bg: '#ffffff',
  header: '#270f2b',
  card: '#3d1540',
  principal: '#270f2b',
  acento: '#94b803',
  morado: '#672369',
  texto: '#ffffff',
  textoSuave: 'rgba(255,255,255,0.5)',
  borde: 'rgba(148,184,3,0.2)',
  navBg: '#ffffff',
  navBorde: '#eee',
  rojo: '#ff1744',
  verde: '#00b894',
  amarillo: '#fdcb6e',
};

const TIPOS_TRABAJO = [
  { id: 'nodos', label: 'Nodos', emoji: '🔵', color: '#5c9adb' },
  { id: 'cctv', label: 'CCTV', emoji: '🔴', color: '#ef4444' },
  { id: 'ap', label: 'AP', emoji: '🟢', color: '#22c55e' },
  { id: 'rack', label: 'Rack', emoji: '🟠', color: '#f97316' },
  { id: 'arcos', label: 'Arcos', emoji: '🟣', color: '#a855f7' },
  { id: 'cableado', label: 'Cableado', emoji: '⚫', color: '#6b7280' },
];

const ZONAS = [
  { id: 1, nombre: 'Registro de Clientes', emoji: '📋', tam: 'med' },
  { id: 2, nombre: 'Entrada VIP', emoji: '⭐', tam: 'med' },
  { id: 3, nombre: 'Zona de Stands', emoji: '🏢', tam: 'grande' },
  { id: 4, nombre: 'Zona de Alimentos', emoji: '🍽️', tam: 'grande' },
  { id: 5, nombre: 'Cajas', emoji: '💳', tam: 'peq' },
  { id: 6, nombre: 'Centro de Negocios', emoji: '💼', tam: 'med' },
  { id: 7, nombre: 'Zona VIP', emoji: '🌟', tam: 'med' },
  { id: 8, nombre: 'Registro de Proveedores', emoji: '📦', tam: 'peq' },
  { id: 9, nombre: 'Bodegas', emoji: '🏭', tam: 'grande' },
  { id: 10, nombre: 'Seguridad', emoji: '🔒', tam: 'peq' },
];

const TABS = [
  { id: 'dashboard', emoji: '📊', label: 'Avances' },
  { id: 'mapa', emoji: '🗺️', label: 'Mapa' },
  { id: 'personas', emoji: '👥', label: 'Personas' },
  { id: 'almacen', emoji: '🏪', label: 'Almacén' },
  { id: 'gastos', emoji: '💰', label: 'Gastos' },
  { id: 'incidentes', emoji: '🚨', label: 'Incidentes' },
];

const ZONA_COLORES = [
  { bg: '#f5f0f7', borde: '#9b59b6', texto: '#2d0a3a' },
  { bg: '#f0f5f0', borde: '#94b803', texto: '#1a2d00' },
  { bg: '#f7f0f5', borde: '#672369', texto: '#2d0a2a' },
  { bg: '#f5f5f0', borde: '#8b7355', texto: '#2d2000' },
  { bg: '#f0f3f7', borde: '#3d7ab5', texto: '#0a1a2d' },
  { bg: '#f7f5f0', borde: '#b5833d', texto: '#2d1a00' },
  { bg: '#f0f7f5', borde: '#3db58b', texto: '#002d1a' },
  { bg: '#f5f0f7', borde: '#7b3db5', texto: '#1a002d' },
  { bg: '#f7f0f0', borde: '#b53d3d', texto: '#2d0000' },
  { bg: '#f0f7f7', borde: '#3db5b5', texto: '#002d2d' },
];

const FECHAS = {
  montajeInicio: new Date('2026-04-11'),
  montajeFin: new Date('2026-04-14'),
  eventoInicio: new Date('2026-04-15'),
  eventoFin: new Date('2026-04-16'),
  desmontaje: new Date('2026-04-17'),
};

function detectarEtapa() {
  const h = new Date();
  if (h < FECHAS.eventoInicio) return '🔧 Montaje';
  if (h <= FECHAS.eventoFin) return '🎪 Evento';
  return '📦 Desmontaje';
}

function totalPorTipoZona(tipoId, tamZona) {
  const t = { grande: { nodos: 12, cctv: 8, ap: 6, rack: 1, arcos: 0, cableado: 15 },
    med: { nodos: 6, cctv: 4, ap: 3, rack: 1, arcos: 0, cableado: 8 },
    peq: { nodos: 3, cctv: 2, ap: 2, rack: 1, arcos: 0, cableado: 4 } };
  return (t[tamZona] || t.peq)[tipoId] || 0;
}

function arcosParaZona(zonaId) {
  if (zonaId === 2) return 2; // Entrada VIP
  if (zonaId === 10) return 2; // Seguridad
  if (zonaId === 1) return 1; // Registro
  return 0;
}

function crearAvancesIniciales() {
  const av = {};
  ZONAS.forEach(z => {
    av[z.id] = {};
    TIPOS_TRABAJO.forEach(t => {
      let tot = t.id === 'arcos' ? arcosParaZona(z.id) : totalPorTipoZona(t.id, z.tam);
      av[z.id][t.id] = { completadas: 0, total: tot };
    });
  });
  return av;
}

function useAncho() {
  const [w, setW] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  useEffect(() => {
    const h = () => setW(window.innerWidth);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return w;
}



const headers = () => {
  const token = storage.getRaw(STORAGE_KEYS.AUTH_TOKEN);
  return { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
};

function obtenerUbicacion() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) { reject(new Error('Tu dispositivo no soporta geolocalización')); return; }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ latitud: pos.coords.latitude, longitud: pos.coords.longitude, precision: pos.coords.accuracy }),
      (err) => reject(new Error(err.code === 1 ? 'Permiso de ubicación denegado' : err.code === 2 ? 'No se pudo obtener la ubicación' : 'Tiempo agotado')),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });
}

function tiempoRel(fecha) {
  const d = Math.floor((Date.now() - new Date(fecha).getTime()) / 60000);
  if (d < 1) return 'ahora';
  if (d < 60) return `hace ${d} min`;
  if (d < 1440) return `hace ${Math.floor(d / 60)}h`;
  return `hace ${Math.floor(d / 1440)}d`;
}

// ============================================
// COMPONENTE PRINCIPAL
// ============================================
export default function ExpoAlianza({ usuario, onLogout, onSalir, modoAplicativo }) {
  const [splash, setSplash] = useState(true);
  const [tab, setTab] = useState('dashboard');
  const [zonaSeleccionada, setZonaSeleccionada] = useState(null);
  const [tipoFiltro, setTipoFiltro] = useState('nodos');
  const [puntoSeleccionado, setPuntoSeleccionado] = useState(null);
  const [avances, setAvances] = useState(() => crearAvancesIniciales());
  const [asistencias, setAsistencias] = useState([]);
  const [material, setMaterial] = useState([]);
  const [gastos, setGastos] = useState([]);
  const [incidentes, setIncidentes] = useState([]);
  const [horaActual, setHoraActual] = useState(new Date());
  const [resumen, setResumen] = useState(null);
  const [toast, setToast] = useState('');
  const [cargandoDatos, setCargandoDatos] = useState(true);
  const [expoConfig, setExpoConfig] = useState({ logoUrl: '', nombreEvento: 'Expo Alianza', anoEvento: '2026' });
  const [modalConfig, setModalConfig] = useState(false);
  const [panelMas, setPanelMas] = useState(false);
  const [tecnicos, setTecnicos] = useState([]);

  const logoEvento = expoConfig.logoUrl;
  const nombreEvento = expoConfig.nombreEvento;
  const anoEvento = expoConfig.anoEvento;

  const esSupervisor = (() => {
    const r = (usuario?.rol || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    return ['direccion', 'supervisor', 'administracion'].some(x => r.includes(x));
  })();

  const puedeConfigurar = (() => {
    const r = (usuario?.rol || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    return r.includes('direccion');
  })();

  // Cargar config desde servidor
  useEffect(() => {
    const cargarConfig = async () => {
      try {
        const res = await fetch(`${API}/api/expo/config`, { headers: headers() });   // ENCAPSULAR-TUEXPO: con sesion
        const data = await res.json();
        if (data.config) {
          setExpoConfig(data.config);
        }
      } catch (e) {
        // servidor no disponible, usar defaults
      }
    };
    cargarConfig();
  }, []);

  const guardarConfig = async (nuevaConfig) => {
    console.log('Guardando config...', { logoSize: nuevaConfig.logoUrl?.length, nombre: nuevaConfig.nombreEvento });
    try {
      const token = storage.getRaw(STORAGE_KEYS.AUTH_TOKEN);
      const res = await fetch(`${API}/api/expo/config`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(nuevaConfig),
      });
      console.log('Respuesta servidor:', res.status);
      if (res.ok) {
        setExpoConfig(nuevaConfig);
      } else {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Error del servidor: ' + res.status);
      }
    } catch (e) {
      console.error('Error guardando config:', e);
      // Fallback: al menos actualizar estado local
      setExpoConfig(nuevaConfig);
    }
  };

  useEffect(() => { const t = setTimeout(() => setSplash(false), 2500); return () => clearTimeout(t); }, []);

  // Persistir que estamos en Expo
  useEffect(() => { storage.set(STORAGE_KEYS.CURRENT_APP, 'expo'); }, []);

  useEffect(() => { const t = setInterval(() => setHoraActual(new Date()), 1000); return () => clearInterval(t); }, []);

  const mostrarToast = useCallback((m) => { setToast(m); setTimeout(() => setToast(''), 2500); }, []);

  // ─── CARGA DE DATOS DESDE API ────────────────────
  const cargarDatos = useCallback(async () => {
    const h = headers();
    try {
      // Resumen (incluye init si necesario)
      let resData;
      const resRes = await fetch(`${API}/api/expo/resumen`, { headers: h });
      resData = await resRes.json();
      if (!resData.inicializado) {
        await fetch(`${API}/api/expo/init`, { method: 'POST', headers: h });
        const r2 = await fetch(`${API}/api/expo/resumen`, { headers: h });
        resData = await r2.json();
      }
      setResumen(resData);

      const eventoId = resData.evento?.id;

      // Cargar todo en paralelo
      const [avRes, asiRes, incRes, matRes, gasRes] = await Promise.all([
        fetch(`${API}/api/expo/avances`, { headers: h }).then(r => r.json()).catch(() => ({ avances: {} })),
        eventoId
          ? fetch(`${API}/api/expo/asistencias/${eventoId}`, { headers: h }).then(r => r.json()).catch(() => ({ asistencias: [] }))
          : { asistencias: [] },
        fetch(`${API}/api/expo/incidentes`, { headers: h }).then(r => r.json()).catch(() => ({ incidentes: [] })),
        fetch(`${API}/api/expo/material`, { headers: h }).then(r => r.json()).catch(() => ({ material: [] })),
        fetch(`${API}/api/expo/gastos`, { headers: h }).then(r => r.json()).catch(() => ({ gastos: [] })),
      ]);

      // Merge avances del servidor con estructura local
      if (avRes.avances && Object.keys(avRes.avances).length > 0) {
        setAvances(prev => {
          const merged = JSON.parse(JSON.stringify(prev));
          Object.entries(avRes.avances).forEach(([zid, tipos]) => {
            Object.entries(tipos).forEach(([tipo, data]) => {
              if (tipo === 'nombre' || tipo === 'emoji') return;
              if (merged[zid] && merged[zid][tipo]) {
                merged[zid][tipo].completadas = data.completadas;
                merged[zid][tipo].total = data.total;
              }
            });
          });
          return merged;
        });
      }

      setAsistencias(asiRes.asistencias || []);
      setIncidentes((incRes.incidentes || []).map(i => ({
        id: i.id, estado: i.estado === 'incidente' ? 'activo' : 'resuelto',
        zona: i.zona_nombre, zonaId: i.area_id, zonaEmoji: i.zona_emoji || '',
        tipoInstalacion: (i.titulo || '').replace('INCIDENTE: ', ''), tipoEmoji: '',
        descripcion: i.descripcion, urgencia: i.prioridad || 'media',
        foto: i.foto_url || '', reportadoPor: i.tecnico_nombre || '',
        fecha: i.creado_en, resueltoPor: i.estado === 'completado' ? 'Resuelto' : '',
        resueltoEn: i.completado_en || '',
      })));
      setMaterial(matRes.material || []);
      setGastos(gasRes.gastos || []);

      // Cargar técnicos activos
      fetch(`${API}/api/expo/tecnicos-activos`, { headers: h })
        .then(r => r.json()).then(d => setTecnicos(d.tecnicos || [])).catch(() => {});
    } catch (e) {
      console.error('Error cargando datos Expo:', e);
    } finally {
      setCargandoDatos(false);
    }
  }, []);

  useEffect(() => { cargarDatos(); const i = setInterval(cargarDatos, 30000); return () => clearInterval(i); }, [cargarDatos]);

  // ─── ACCIONES API ────────────────────────────────
  const registrarAsistenciaAPI = async (tipo, extra = {}) => {
    try {
      const eventoId = resumen?.evento?.id;
      const body = extra.manual
        ? { tipo, evento_id: eventoId, nombre_manual: extra.nombre, empresa_manual: extra.empresa }
        : { tipo, usuario_id: usuario?.id, evento_id: eventoId };

      const res = await fetch(`${API}/api/expo/asistencia`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Error al registrar asistencia');
      }

      // Refresh asistencias
      if (eventoId) {
        const r = await fetch(`${API}/api/expo/asistencias/${eventoId}`, { headers: headers() });
        const d = await r.json();
        setAsistencias(d.asistencias || []);
      }
      return true;
    } catch (e) {
      console.error('Error registrando asistencia:', e);
      return false;
    }
  };

  const actualizarPuntoAPI = async (tareaId, estado, extra = {}) => {
    try {
      await fetch(`${API}/api/expo/punto/${tareaId}`, {
        method: 'PUT', headers: headers(),
        body: JSON.stringify({ estado, tecnico: extra.tecnico, notas: extra.notas, foto_url: extra.foto, usuario_id: usuario?.id }),
      });
      cargarDatos();
    } catch (e) { console.error(e); }
  };

  const reportarIncidenteAPI = async (data) => {
    try {
      await fetch(`${API}/api/expo/incidente`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify(data),
      });
      cargarDatos();
    } catch (e) { console.error(e); }
  };

  const resolverIncidenteAPI = async (id) => {
    try {
      await fetch(`${API}/api/expo/incidente/${id}/resolver`, {
        method: 'PUT', headers: headers(),
        body: JSON.stringify({ usuario_id: usuario?.id }),
      });
      cargarDatos();
    } catch (e) { console.error(e); }
  };

  const registrarMaterialAPI = async (data) => {
    try {
      await fetch(`${API}/api/expo/material`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify(data),
      });
      cargarDatos();
    } catch (e) { console.error(e); }
  };

  const cambiarEstadoMaterialAPI = async (id, estado) => {
    try {
      await fetch(`${API}/api/expo/material/${id}`, {
        method: 'PUT', headers: headers(),
        body: JSON.stringify({ estado }),
      });
      cargarDatos();
    } catch (e) { console.error(e); }
  };

  const registrarGastoAPI = async (data) => {
    try {
      await fetch(`${API}/api/expo/gasto`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify(data),
      });
      cargarDatos();
    } catch (e) { console.error(e); }
  };

  // Calculos
  const calcPorcentajeZona = (zonaId) => {
    let total = 0, comp = 0;
    TIPOS_TRABAJO.forEach(t => {
      const d = avances[zonaId]?.[t.id] || { completadas: 0, total: 0 };
      total += d.total; comp += d.completadas;
    });
    return total > 0 ? Math.round((comp / total) * 100) : 0;
  };

  const calcGlobal = () => {
    let total = 0, comp = 0;
    ZONAS.forEach(z => TIPOS_TRABAJO.forEach(t => {
      const d = avances[z.id]?.[t.id] || { completadas: 0, total: 0 };
      total += d.total; comp += d.completadas;
    }));
    return { total, comp, pct: total > 0 ? Math.round((comp / total) * 100) : 0 };
  };

  const ancho = useAncho();
  const esMovil = ancho < 768;

  const incidentesActivos = incidentes.filter(i => i.estado === 'activo');
  const zonaConIncidente = (zId) => incidentesActivos.some(i => i.zonaId === zId);
  const global = calcGlobal();

  // SPLASH SCREEN
  if (splash) return (
    <div style={{
      position: 'fixed', inset: 0, background: C.principal,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      gap: 24, zIndex: 9999, fontFamily: PP,
    }}>
      <div style={{
        width: 120, height: 120, borderRadius: 24, background: C.card,
        border: `2px solid ${C.borde}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden',
      }}>
        {logoEvento
          ? <img src={logoEvento} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          : <div style={{ fontSize: 48 }}>{'🎪'}</div>
        }
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: C.acento, letterSpacing: 2 }}>
          {(nombreEvento || 'EXPO ALIANZA').toUpperCase()}
        </div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 4, letterSpacing: 3 }}>
          {anoEvento || '2026'}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 6, marginTop: 16 }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width: 6, height: 6, borderRadius: '50%',
            background: C.acento, opacity: 0.3,
            animation: `dotPulse 1.2s ease-in-out ${i * 0.2}s infinite`,
          }} />
        ))}
      </div>
      <style>{`@keyframes dotPulse{0%,100%{opacity:0.3;transform:scale(1)}50%{opacity:1;transform:scale(1.3)}}`}</style>
    </div>
  );

  // Contenido compartido entre layouts
  const contenido = cargandoDatos ? (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40, gap: 10 }}>
      <div style={{ fontSize: 24 }}>{'🎪'}</div>
      <div style={{ color: '#888', fontSize: 13 }}>Cargando datos...</div>
    </div>
  ) : (
    <>
      {tab === 'dashboard' && (
        <TabDashboard
          avances={avances} setAvances={setAvances} global={global} incidentesActivos={incidentesActivos}
          zonaConIncidente={zonaConIncidente} calcPorcentajeZona={calcPorcentajeZona}
          zonaSeleccionada={zonaSeleccionada} setZonaSeleccionada={setZonaSeleccionada}
          tipoFiltro={tipoFiltro} setTipoFiltro={setTipoFiltro}
          puntoSeleccionado={puntoSeleccionado} setPuntoSeleccionado={setPuntoSeleccionado}
          esSupervisor={esSupervisor} usuario={usuario} mostrarToast={mostrarToast}
          enSitio={asistencias.filter(a => a.tipo === 'entrada').length}
          actualizarPuntoAPI={actualizarPuntoAPI}
          tecnicos={tecnicos} asistenciasHoy={asistencias}
          cargarDatos={cargarDatos}
        />
      )}
      {tab === 'mapa' && <MapaExpo usuario={usuario} onVolver={() => setTab('dashboard')} />}
      {tab === 'personas' && (
        <TabPersonas esSupervisor={esSupervisor} usuario={usuario}
          asistencias={asistencias} horaActual={horaActual}
          registrarAsistenciaAPI={registrarAsistenciaAPI}
          material={material} registrarMaterialAPI={registrarMaterialAPI}
          cambiarEstadoMaterialAPI={cambiarEstadoMaterialAPI}
          mostrarToast={mostrarToast} tecnicos={tecnicos} />
      )}
      {tab === 'almacen' && (
        <TabAlmacen esSupervisor={esSupervisor} usuario={usuario} mostrarToast={mostrarToast} />
      )}
      {tab === 'gastos' && (
        <TabGastos usuario={usuario} gastos={gastos} registrarGastoAPI={registrarGastoAPI} mostrarToast={mostrarToast} />
      )}
      {tab === 'incidentes' && (
        <TabIncidentes incidentes={incidentes} reportarIncidenteAPI={reportarIncidenteAPI}
          resolverIncidenteAPI={resolverIncidenteAPI} usuario={usuario} mostrarToast={mostrarToast} />
      )}
    </>
  );

  const tabActiva = TABS.find(t => t.id === tab);

  return (
    <div style={{ display: 'flex', height: '100dvh', fontFamily: PP, background: C.bg, flexDirection: esMovil ? 'column' : 'row', overflow: 'hidden' }}>
      <style>{`
        @keyframes pulsoRojo{0%,100%{box-shadow:0 0 0 0 rgba(255,23,68,0.4)}50%{box-shadow:0 0 0 8px rgba(255,23,68,0)}}
        .pulso-borde{animation:pulsoRojo 1.2s ease-in-out infinite}
        @keyframes pulsoOp{0%,100%{opacity:1}50%{opacity:0.5}}
        .pulso-op{animation:pulsoOp 1s ease-in-out infinite}
        .expo-sidebar-item:hover{background:rgba(148,184,3,0.1)!important}
      `}</style>

      {/* ===== SIDEBAR DESKTOP ===== */}
      {!esMovil && (
        <div style={{
          width: 240, background: C.principal, display: 'flex', flexDirection: 'column',
          flexShrink: 0, borderRight: '1px solid rgba(148,184,3,0.15)',
        }}>
          {/* Logo */}
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            padding: '20px 16px 16px', borderBottom: '1px solid rgba(148,184,3,0.2)',
          }}>
            <div style={{
              width: 80, height: 80, borderRadius: 16, background: C.card,
              border: '2px solid rgba(148,184,3,0.3)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              overflow: 'hidden', marginBottom: 10,
            }}>
              {logoEvento
                ? <img src={logoEvento} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                : <span style={{ fontSize: 36 }}>{'🎪'}</span>
              }
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: C.acento, letterSpacing: 1, textAlign: 'center' }}>
              {(nombreEvento || 'EXPO ALIANZA').toUpperCase()}
            </div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', letterSpacing: 2, marginTop: 2 }}>
              {anoEvento || '2026'}
            </div>
          </div>

          {/* Etapa */}
          <div style={{ padding: '10px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <div style={{
              background: C.morado, borderRadius: 8, padding: '6px 12px', fontSize: 11,
              fontWeight: 600, color: '#fff', textAlign: 'center',
            }}>{detectarEtapa()}</div>
          </div>

          {/* Nav items */}
          <nav style={{ padding: '8px 0', flex: 1, overflowY: 'auto' }}>
            {TABS.map(t => {
              const activa = tab === t.id;
              const alerta = t.id === 'incidentes' && incidentesActivos.length > 0;
              return (
                <div
                  key={t.id}
                  className="expo-sidebar-item"
                  onClick={() => { setTab(t.id); setZonaSeleccionada(null); }}
                  style={{
                    padding: '12px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                    color: activa ? C.principal : 'rgba(255,255,255,0.6)',
                    background: activa ? C.acento : 'transparent',
                    borderLeft: activa ? `3px solid ${C.acento}` : '3px solid transparent',
                    fontWeight: activa ? 700 : 500, fontSize: 13,
                    transition: 'all 0.15s', position: 'relative',
                    borderRadius: activa ? '0 8px 8px 0' : 0,
                    marginRight: 8,
                  }}
                >
                  <span style={{ fontSize: 18 }}>{t.emoji}</span>
                  <span>{t.label}</span>
                  {alerta && <div className="pulso-op" style={{
                    width: 8, height: 8, borderRadius: '50%', background: C.rojo, marginLeft: 'auto',
                  }} />}
                </div>
              );
            })}
          </nav>

          {/* Config + Salir */}
          <div style={{ padding: '8px 0', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
            {puedeConfigurar && (
              <div className="expo-sidebar-item" onClick={() => setModalConfig(true)} style={{
                padding: '10px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                color: 'rgba(255,255,255,0.5)', fontSize: 13, transition: 'all 0.15s',
              }}>
                <span style={{ fontSize: 16 }}>{'⚙️'}</span>
                <span>Configuración</span>
              </div>
            )}
            {modoAplicativo && onSalir && (
              <div className="expo-sidebar-item" onClick={onSalir} style={{
                padding: '10px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                color: 'rgba(255,255,255,0.4)', fontSize: 12, transition: 'all 0.15s',
              }}>
                <span>{'←'}</span>
                <span>Beep OS</span>
              </div>
            )}
            {!modoAplicativo && onLogout && (
              <div className="expo-sidebar-item" onClick={onLogout} style={{
                padding: '10px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                color: 'rgba(255,255,255,0.4)', fontSize: 12, transition: 'all 0.15s',
              }}>
                <span>{'🚪'}</span>
                <span>Cerrar sesión</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ===== MAIN CONTENT ===== */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', paddingBottom: esMovil ? 0 : 0 }}>

        {/* HEADER MÓVIL */}
        {esMovil && (
          <div style={{
            background: C.header, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 8,
            flexShrink: 0,
          }}>
            {modoAplicativo && onSalir && (
              <button onClick={onSalir} style={{
                background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
                color: '#e9e9e9', fontSize: 11, cursor: 'pointer', padding: '4px 8px',
                fontFamily: PP, borderRadius: 6,
              }}>{'←'} Beep</button>
            )}
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 44, height: 44, borderRadius: 10, background: C.card,
                border: '1px solid rgba(148,184,3,0.3)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                overflow: 'hidden', flexShrink: 0,
              }}>
                {expoConfig.logoUrl
                  ? <img src={expoConfig.logoUrl} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  : <span style={{ fontSize: 24 }}>{'🎪'}</span>
                }
              </div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800, color: C.acento, letterSpacing: 1 }}>
                  {(expoConfig.nombreEvento || 'EXPO ALIANZA').toUpperCase()}
                </div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', letterSpacing: 1 }}>
                  {expoConfig.anoEvento || '2026'}
                </div>
              </div>
            </div>
            <div style={{
              background: C.morado, borderRadius: 14, padding: '3px 8px', fontSize: 9,
              fontWeight: 600, color: '#fff', whiteSpace: 'nowrap',
            }}>{detectarEtapa()}</div>
            {puedeConfigurar && (
              <button onClick={() => setModalConfig(true)} style={{
                background: 'rgba(255,255,255,0.1)', border: 'none', color: 'rgba(255,255,255,0.6)',
                borderRadius: 6, padding: '2px 6px', fontSize: 14, cursor: 'pointer',
                minWidth: 28, minHeight: 28, display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>{'⚙️'}</button>
            )}
            {!modoAplicativo && onLogout && (
              <button onClick={onLogout} style={{
                background: 'rgba(255,255,255,0.1)', border: 'none', color: '#ccc',
                borderRadius: 6, padding: '3px 7px', fontSize: 10, cursor: 'pointer', fontFamily: PP,
              }}>Salir</button>
            )}
          </div>
        )}

        {/* TOPBAR DESKTOP */}
        {!esMovil && (
          <div style={{
            background: '#fff', borderBottom: '1px solid #e8e8e8', padding: '10px 24px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0,
          }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: C.principal, display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ fontSize: 18 }}>{tabActiva?.emoji}</span>
              {tabActiva?.label}
            </div>
            <div style={{ fontSize: 12, color: '#888' }}>
              {new Date().toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
            </div>
          </div>
        )}

        {/* SCROLL CONTENT */}
        <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
          {contenido}
        </div>

        {/* BOTTOM NAV MÓVIL */}
        {esMovil && (
          <>
            <div style={{
              flexShrink: 0, background: C.principal, borderTop: '1px solid rgba(255,255,255,0.1)',
              display: 'flex', alignItems: 'center', height: 64,
              paddingBottom: 'env(safe-area-inset-bottom, 0px)',
            }}>
              {TABS.slice(0, 4).map(t => {
                const activa = tab === t.id;
                return (
                  <div key={t.id} onClick={() => { setTab(t.id); setZonaSeleccionada(null); setPanelMas(false); }} style={{
                    flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', cursor: 'pointer', height: '100%', position: 'relative',
                  }}>
                    <div style={{
                      width: activa ? 44 : 36, height: activa ? 44 : 36, borderRadius: 14,
                      background: activa ? C.acento : 'transparent',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: activa ? 18 : 22,
                      transition: 'all 0.25s cubic-bezier(0.32,0.72,0,1)',
                      boxShadow: activa ? '0 4px 14px rgba(148,184,3,0.4)' : 'none',
                    }}>{t.emoji}</div>
                    {activa && (
                      <div style={{ fontSize: 9, fontWeight: 700, color: C.acento, marginTop: 2 }}>{t.label}</div>
                    )}
                  </div>
                );
              })}
              {/* Botón Más */}
              <div onClick={() => setPanelMas(p => !p)} style={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', cursor: 'pointer', height: '100%', position: 'relative',
              }}>
                <div style={{
                  width: panelMas ? 40 : 36, height: panelMas ? 40 : 36, borderRadius: 14,
                  background: panelMas ? 'rgba(255,255,255,0.2)' : 'transparent',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 22, transition: 'all 0.25s',
                }}>{panelMas ? '✕' : '⋮⋮'}</div>
                {incidentesActivos.length > 0 && !panelMas && (
                  <div className="pulso-op" style={{
                    position: 'absolute', top: 6, right: '22%', width: 7, height: 7,
                    borderRadius: '50%', background: C.rojo,
                  }} />
                )}
              </div>
            </div>

            {/* Panel Más */}
            {panelMas && (
              <div style={{ position: 'fixed', inset: 0, zIndex: 90, fontFamily: PP }}>
                <div onClick={() => setPanelMas(false)} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)' }} />
                <div style={{
                  position: 'absolute', bottom: 0, left: 0, right: 0,
                  background: C.principal, borderRadius: '20px 20px 0 0',
                  paddingBottom: 'calc(64px + env(safe-area-inset-bottom, 0px))',
                }}>
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 8px' }}>
                    <div style={{ width: 40, height: 4, borderRadius: 2, background: 'rgba(255,255,255,0.2)' }} />
                  </div>
                  {[
                    { id: 'gastos', emoji: '💰', label: 'Gastos' },
                    { id: 'incidentes', emoji: '🚨', label: 'Incidentes' },
                  ].map(item => (
                    <div key={item.id} onClick={() => { setTab(item.id); setZonaSeleccionada(null); setPanelMas(false); }} style={{
                      padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 14,
                      cursor: 'pointer', color: tab === item.id ? C.acento : 'rgba(255,255,255,0.7)',
                      background: tab === item.id ? 'rgba(148,184,3,0.1)' : 'transparent',
                      transition: 'all 0.15s', fontSize: 15, fontWeight: tab === item.id ? 700 : 500,
                    }}>
                      <span style={{ fontSize: 22 }}>{item.emoji}</span>
                      <span>{item.label}</span>
                      {item.id === 'incidentes' && incidentesActivos.length > 0 && (
                        <div className="pulso-op" style={{
                          width: 8, height: 8, borderRadius: '50%', background: C.rojo, marginLeft: 'auto',
                        }} />
                      )}
                    </div>
                  ))}
                  {puedeConfigurar && (
                    <div onClick={() => { setModalConfig(true); setPanelMas(false); }} style={{
                      padding: '14px 24px', display: 'flex', alignItems: 'center', gap: 14,
                      cursor: 'pointer', color: 'rgba(255,255,255,0.7)',
                      transition: 'all 0.15s', fontSize: 15,
                    }}>
                      <span style={{ fontSize: 22 }}>{'⚙️'}</span>
                      <span>Configuración</span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* MODAL CONFIGURACIÓN */}
      {modalConfig && (
        <ConfigModal
          config={expoConfig}
          onGuardar={(nuevoConfig) => {
            guardarConfig(nuevoConfig);
            setModalConfig(false);
            mostrarToast('Configuración guardada');
          }}
          onCerrar={() => setModalConfig(false)}
        />
      )}

      {toast && (
        <div style={{
          position: 'fixed', bottom: esMovil ? 70 : 24, left: '50%', transform: 'translateX(-50%)',
          background: C.verde, color: '#fff', padding: '10px 20px', borderRadius: 10,
          fontSize: 13, fontWeight: 600, zIndex: 200, fontFamily: PP,
        }}>{'✅'} {toast}</div>
      )}
    </div>
  );
}

// ============================================
// PLANO SVG INTERACTIVO
// ============================================
function PlanoExpoSVG({ zonas, avances, calcPorcentajeZona, zonaConIncidente, onZonaClick }) {
  const layout = [
    { id: 1, x: 5, y: 5, w: 22, h: 18 },
    { id: 2, x: 29, y: 5, w: 22, h: 18 },
    { id: 6, x: 53, y: 5, w: 22, h: 18 },
    { id: 7, x: 77, y: 5, w: 18, h: 18 },
    { id: 3, x: 5, y: 27, w: 44, h: 26 },
    { id: 4, x: 51, y: 27, w: 44, h: 26 },
    { id: 5, x: 5, y: 57, w: 16, h: 16 },
    { id: 8, x: 23, y: 57, w: 22, h: 16 },
    { id: 9, x: 47, y: 57, w: 30, h: 16 },
    { id: 10, x: 79, y: 57, w: 16, h: 16 },
  ];

  const colorPct = (pct) => {
    if (pct >= 100) return { fill: '#e8f5e9', stroke: C.acento, text: '#1b5e20' };
    if (pct >= 75) return { fill: '#f1f8e9', stroke: '#8bc34a', text: '#33691e' };
    if (pct >= 50) return { fill: '#fff8e1', stroke: C.amarillo, text: '#f57f17' };
    if (pct >= 25) return { fill: '#fff3e0', stroke: '#ff9800', text: '#e65100' };
    if (pct > 0) return { fill: '#fce4ec', stroke: '#ef9a9a', text: '#c62828' };
    return { fill: '#f5f5f5', stroke: '#bdbdbd', text: '#757575' };
  };

  return (
    <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e0e0e0', padding: 8, marginBottom: 16 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#999', marginBottom: 6, letterSpacing: 1, textTransform: 'uppercase', padding: '0 4px' }}>
        Plano del evento
      </div>
      <svg viewBox="0 0 100 78" style={{ width: '100%', height: 'auto' }}>
        {layout.map(l => {
          const zona = zonas.find(z => z.id === l.id);
          if (!zona) return null;
          const pct = calcPorcentajeZona(zona.id);
          const inc = zonaConIncidente(zona.id);
          const c = inc ? { fill: '#ffebee', stroke: C.rojo, text: '#c62828' } : colorPct(pct);
          return (
            <g key={zona.id} onClick={() => onZonaClick(zona.id)} style={{ cursor: 'pointer' }}>
              <rect x={l.x} y={l.y} width={l.w} height={l.h} rx={2} ry={2}
                fill={c.fill} stroke={c.stroke} strokeWidth={inc ? 1.2 : 0.6}
                className={inc ? 'pulso-borde' : ''} />
              <text x={l.x + l.w / 2} y={l.y + l.h / 2 - 2} textAnchor="middle"
                fill={c.text} fontSize={l.w < 20 ? 2.5 : 3} fontWeight="700" fontFamily={PP}>
                {zona.emoji}
              </text>
              <text x={l.x + l.w / 2} y={l.y + l.h / 2 + 2.5} textAnchor="middle"
                fill={c.text} fontSize={l.w < 20 ? 2 : 2.5} fontWeight="600" fontFamily={PP}>
                {zona.nombre.length > 14 ? zona.nombre.slice(0, 12) + '..' : zona.nombre}
              </text>
              <text x={l.x + l.w / 2} y={l.y + l.h / 2 + 6} textAnchor="middle"
                fill={c.text} fontSize={2.8} fontWeight="900" fontFamily={PP}>
                {pct}%
              </text>
              {/* Barra de progreso mini */}
              <rect x={l.x + 2} y={l.y + l.h - 3} width={l.w - 4} height={1.2} rx={0.6}
                fill="rgba(0,0,0,0.08)" />
              <rect x={l.x + 2} y={l.y + l.h - 3} width={Math.max(0, (l.w - 4) * pct / 100)} height={1.2} rx={0.6}
                fill={pct >= 100 ? C.acento : c.stroke} />
            </g>
          );
        })}
      </svg>
    </div>
  );
}

// ============================================
// TAB DASHBOARD (Avance del montaje)
// ============================================
function TabDashboard({ avances, setAvances, global, incidentesActivos, zonaConIncidente, calcPorcentajeZona,
  zonaSeleccionada, setZonaSeleccionada, tipoFiltro, setTipoFiltro,
  puntoSeleccionado, setPuntoSeleccionado, esSupervisor, usuario, mostrarToast, enSitio, actualizarPuntoAPI,
  tecnicos, asistenciasHoy, cargarDatos }) {

  const [modoSeleccion, setModoSeleccion] = useState(false);
  const [puntosSeleccionados, setPuntosSeleccionados] = useState([]);
  const [modalAsignar, setModalAsignar] = useState(false);
  const [pasoAsignar, setPasoAsignar] = useState(1);
  const [tecnicoAsignar, setTecnicoAsignar] = useState(null);
  const [materialAsignar, setMaterialAsignar] = useState([]);
  const [categorias, setCategorias] = useState([]);

  // Tech own tasks
  const [misTareas, setMisTareas] = useState([]);
  const [miMaterialTec, setMiMaterialTec] = useState([]);
  const [cargandoMis, setCargandoMis] = useState(false);
  const [tareaDetalle, setTareaDetalle] = useState(null);
  const [fotoTarea, setFotoTarea] = useState('');

  useEffect(() => {
    if (!esSupervisor && usuario?.id) {
      setCargandoMis(true);
      fetch(`${API}/api/expo/mis-tareas/${usuario.id}`, { headers: headers() })
        .then(r => r.json())
        .then(d => { setMisTareas(d.tareas || []); setMiMaterialTec(d.material || []); })
        .catch(() => {})
        .finally(() => setCargandoMis(false));
    }
  }, [esSupervisor, usuario?.id]);

  // Load kits for material assignment
  useEffect(() => {
    if (esSupervisor) {
      fetch(`${API}/api/expo/kits`, { headers: headers() })
        .then(r => r.json()).then(d => setCategorias(d.kits || [])).catch(() => {});
    }
  }, [esSupervisor]);

  const togglePuntoSel = (p) => {
    setPuntosSeleccionados(prev =>
      prev.some(x => x.num === p.num) ? prev.filter(x => x.num !== p.num) : [...prev, p]
    );
  };

  const asignarMultiples = async () => {
    if (!tecnicoAsignar || puntosSeleccionados.length === 0) return;
    const tareaIds = puntosSeleccionados.filter(p => p.id).map(p => p.id);
    if (tareaIds.length === 0) { mostrarToast('No hay tareas reales para asignar'); return; }
    try {
      await fetch(`${API}/api/expo/asignar-multiples`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify({
          tarea_ids: tareaIds, tecnico_id: tecnicoAsignar.id,
          material_items: materialAsignar.length > 0 ? materialAsignar : null,
          asignado_por: usuario?.id,
        }),
      });
      mostrarToast(`${tareaIds.length} puntos asignados a ${tecnicoAsignar.nombre}`);
      setModalAsignar(false); setModoSeleccion(false); setPuntosSeleccionados([]);
      setTecnicoAsignar(null); setMaterialAsignar([]); setPasoAsignar(1);
      if (cargarDatos) cargarDatos();
    } catch (e) { mostrarToast('Error al asignar'); }
  };

  const handleFotoTarea = (e) => {
    const f = e.target.files[0]; if (!f) return;
    const r = new FileReader();
    r.onload = (ev) => setFotoTarea(ev.target.result);
    r.readAsDataURL(f);
  };

  const completarMiTarea = async (tarea) => {
    if (!fotoTarea) { mostrarToast('Se requiere foto para completar'); return; }
    try {
      await fetch(`${API}/api/expo/punto/${tarea.id}`, {
        method: 'PUT', headers: headers(),
        body: JSON.stringify({ estado: 'completado', foto_url: fotoTarea, usuario_id: usuario?.id }),
      });
      mostrarToast('Tarea completada');
      setTareaDetalle(null); setFotoTarea('');
      // Reload
      const d = await fetch(`${API}/api/expo/mis-tareas/${usuario.id}`, { headers: headers() }).then(r => r.json());
      setMisTareas(d.tareas || []); setMiMaterialTec(d.material || []);
      if (cargarDatos) cargarDatos();
    } catch (e) { mostrarToast('Error'); }
  };

  const tecnicosEnSitio = (tecnicos || []).filter(t => t.hora_entrada);

  // ═══════════════════════════════════
  // VISTA TÉCNICO: "Mis tareas de hoy"
  // ═══════════════════════════════════
  if (!esSupervisor) {
    const enProceso = misTareas.filter(t => t.estado === 'en_proceso');
    const pendientes = misTareas.filter(t => t.estado === 'pendiente');
    const completadas = misTareas.filter(t => t.estado === 'completado');

    return (
      <div style={{ padding: 16 }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: C.principal, marginBottom: 4 }}>Mis tareas de hoy</div>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>
          {completadas.length} completadas, {enProceso.length} en proceso, {pendientes.length} pendientes
        </div>

        {cargandoMis && <div style={{ textAlign: 'center', color: '#aaa', padding: 20 }}>Cargando...</div>}

        {!cargandoMis && misTareas.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>{'📋'}</div>
            No tienes tareas asignadas hoy
          </div>
        )}

        {/* Tareas en proceso */}
        {enProceso.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#e65100', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>
              {'🔄'} En proceso ({enProceso.length})
            </div>
            {enProceso.map(t => {
              const mins = t.creado_en ? Math.round((Date.now() - new Date(t.creado_en).getTime()) / 60000) : 0;
              const alertaTiempo = mins > 180;
              return (
                <div key={t.id} onClick={() => { setTareaDetalle(t); setFotoTarea(''); }} style={{
                  background: '#fff8e1', borderRadius: 12, padding: 14, marginBottom: 8,
                  border: alertaTiempo ? `2px solid ${C.rojo}` : '1px solid #ffe082',
                  cursor: 'pointer', position: 'relative',
                }}>
                  {alertaTiempo && (
                    <div className="pulso-op" style={{
                      position: 'absolute', top: 8, right: 8, background: C.rojo, color: '#fff',
                      fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 8,
                    }}>{'⚠️'} {Math.floor(mins / 60)}h+</div>
                  )}
                  <div style={{ fontSize: 14, fontWeight: 700, color: C.principal }}>{t.titulo}</div>
                  <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                    {t.zona_emoji} {t.zona_nombre}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Tareas pendientes */}
        {pendientes.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>
              {'⏳'} Pendientes ({pendientes.length})
            </div>
            {pendientes.map(t => (
              <div key={t.id} onClick={() => { setTareaDetalle(t); setFotoTarea(''); }} style={{
                background: '#fff', borderRadius: 12, padding: 14, marginBottom: 8,
                border: '1px solid #eee', cursor: 'pointer',
              }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: C.principal }}>{t.titulo}</div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{t.zona_emoji} {t.zona_nombre}</div>
              </div>
            ))}
          </div>
        )}

        {/* Tareas completadas */}
        {completadas.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.verde, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>
              {'✅'} Completadas ({completadas.length})
            </div>
            {completadas.map(t => (
              <div key={t.id} style={{
                background: '#f0faf0', borderRadius: 12, padding: 12, marginBottom: 6,
                border: '1px solid #c8e6c9',
              }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#2e7d32' }}>{t.titulo}</div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                  {t.zona_emoji} {t.zona_nombre}
                  {t.completado_en && <span> {'•'} {new Date(t.completado_en).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Mi material */}
        {miMaterialTec.length > 0 && (
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: C.principal, marginBottom: 8, marginTop: 8 }}>
              {'📦'} Mi material
            </div>
            {miMaterialTec.map(m => (
              <div key={m.id} style={{
                background: '#fff', borderRadius: 12, padding: 12, marginBottom: 6, border: '1px solid #eee',
              }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: C.principal }}>{m.kit_nombre || 'Material'}</div>
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                  {(m.items_asignados || m.kit_items || []).map((it, i) => (
                    <span key={i}>{it.nombre} x{it.cantidad}{i < (m.items_asignados || m.kit_items || []).length - 1 ? ', ' : ''}</span>
                  ))}
                </div>
                <div style={{ fontSize: 10, fontWeight: 600, color: m.estado === 'entregado' ? C.amarillo : C.verde, marginTop: 4, textTransform: 'capitalize' }}>
                  {m.estado === 'entregado' ? 'En poder' : m.estado}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Modal detalle tarea para completar */}
        {tareaDetalle && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100, fontFamily: PP }}>
            <div onClick={() => setTareaDetalle(null)} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)' }} />
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0, background: '#fff',
              borderRadius: '20px 20px 0 0', maxHeight: '85dvh', overflowY: 'auto',
            }}>
              <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 4px' }}>
                <div style={{ width: 40, height: 4, borderRadius: 2, background: '#ddd' }} />
              </div>
              <div style={{ padding: '8px 20px 12px', borderBottom: '1px solid #eee' }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>{tareaDetalle.titulo}</div>
                <div style={{ fontSize: 12, color: '#888' }}>{tareaDetalle.zona_emoji} {tareaDetalle.zona_nombre}</div>
              </div>
              <div style={{ padding: '16px 20px 32px' }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>
                  Estado: <span style={{
                    color: tareaDetalle.estado === 'completado' ? C.verde : tareaDetalle.estado === 'en_proceso' ? '#e65100' : '#888',
                    textTransform: 'capitalize',
                  }}>{tareaDetalle.estado === 'en_proceso' ? 'En proceso' : tareaDetalle.estado}</span>
                </div>

                {tareaDetalle.estado !== 'completado' && (
                  <>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4, marginTop: 16 }}>
                      Foto evidencia <span style={{ color: C.rojo }}>*obligatoria</span>
                    </div>
                    {fotoTarea ? (
                      <div style={{ position: 'relative', marginBottom: 12 }}>
                        <img src={fotoTarea} alt="" style={{ width: '100%', borderRadius: 10, maxHeight: 200, objectFit: 'cover' }} />
                        <label style={{ position: 'absolute', bottom: 6, right: 6, background: 'rgba(0,0,0,0.6)', color: '#fff', borderRadius: 6, padding: '4px 10px', fontSize: 11, cursor: 'pointer' }}>
                          Cambiar <input type="file" accept="image/*" capture="environment" onChange={handleFotoTarea} style={{ display: 'none' }} />
                        </label>
                      </div>
                    ) : (
                      <label style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                        background: '#fafafa', border: '2px dashed #ddd', borderRadius: 10,
                        padding: 24, cursor: 'pointer', color: '#aaa', fontSize: 13, marginBottom: 12,
                      }}>
                        {'📷'} Tomar foto de evidencia
                        <input type="file" accept="image/*" capture="environment" onChange={handleFotoTarea} style={{ display: 'none' }} />
                      </label>
                    )}

                    <button onClick={() => completarMiTarea(tareaDetalle)} disabled={!fotoTarea} style={{
                      width: '100%', padding: 14, borderRadius: 12, border: 'none', fontSize: 15, fontWeight: 700,
                      fontFamily: PP, cursor: fotoTarea ? 'pointer' : 'default',
                      background: fotoTarea ? C.acento : '#ddd',
                      color: fotoTarea ? C.principal : '#999',
                    }}>{'✅'} Marcar completado</button>
                  </>
                )}

                {tareaDetalle.foto_url && (
                  <div style={{ marginTop: 12 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>Foto evidencia</div>
                    <img src={tareaDetalle.foto_url} alt="" style={{ width: '100%', borderRadius: 10, maxHeight: 200, objectFit: 'cover' }} />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ═══════════════════════════════════
  // NIVEL 2 - VISTA DETALLE ZONA
  // ═══════════════════════════════════
  if (zonaSeleccionada !== null) {
    const zona = ZONAS.find(z => z.id === zonaSeleccionada);

    // Caso especial: Zona de Stands → abrir directamente ZonaStands
    if (zona && (zona.id === 3 || (zona.nombre || '').toLowerCase().includes('stand'))) {
      return <ZonaStands usuario={usuario} onVolver={() => setZonaSeleccionada(null)} />;
    }

    const pctZ = calcPorcentajeZona(zonaSeleccionada);
    const tipoObj = TIPOS_TRABAJO.find(t => t.id === tipoFiltro);
    const datosTipo = avances[zonaSeleccionada]?.[tipoFiltro] || { completadas: 0, total: 0 };

    const puntosReales = datosTipo.puntos || [];
    const puntos = puntosReales.length > 0 ? puntosReales.map((p, i) => ({
      num: i + 1, id: p.id, estado: p.estado, tecnico: p.tecnico || '',
      hora: p.hora || '', foto: p.foto || '', notas: p.notas || '',
    })) : Array.from({ length: datosTipo.total }, (_, i) => ({
      num: i + 1, estado: i < datosTipo.completadas ? 'completado' : 'pendiente',
      tecnico: '', hora: '', foto: '', notas: '',
    }));

    const actualizarPunto = async (num, nuevoEstado, extra = {}) => {
      const punto = puntos.find(p => p.num === num);
      if (punto?.id && actualizarPuntoAPI) {
        await actualizarPuntoAPI(punto.id, nuevoEstado, extra);
      } else {
        setAvances(prev => {
          const n = JSON.parse(JSON.stringify(prev));
          const d = n[zonaSeleccionada]?.[tipoFiltro];
          if (!d) return n;
          if (nuevoEstado === 'completado' && num > d.completadas) d.completadas = Math.min(d.completadas + 1, d.total);
          else if (nuevoEstado === 'pendiente' && d.completadas > 0) d.completadas = Math.max(d.completadas - 1, 0);
          return n;
        });
      }
      mostrarToast(nuevoEstado === 'completado' ? 'Punto completado' : 'Estado actualizado');
      setPuntoSeleccionado(null);
    };

    const estadoColor = (est) => {
      if (est === 'completado') return { bg: `${C.acento}22`, color: C.acento, label: 'Completado' };
      if (est === 'en_proceso') return { bg: '#fff3cd', color: '#8d6e00', label: 'En proceso' };
      if (est === 'incidente') return { bg: '#ffebee', color: C.rojo, label: 'Incidente' };
      return { bg: `${C.morado}33`, color: '#aaa', label: 'Pendiente' };
    };

    return (
      <div style={{ padding: 16 }}>
        {/* Bottom sheet punto (NIVEL 3) */}
        {puntoSeleccionado && (
          <BottomSheetPunto
            punto={puntoSeleccionado} zona={zona} tipo={tipoObj} usuario={usuario}
            onGuardar={(est, extra) => actualizarPunto(puntoSeleccionado.num, est, extra)}
            onCerrar={() => setPuntoSeleccionado(null)}
          />
        )}

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
          <button onClick={() => { setZonaSeleccionada(null); setModoSeleccion(false); setPuntosSeleccionados([]); }} style={{
            background: C.card, border: 'none', color: '#fff', borderRadius: 10,
            padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
          }}>{'←'}</button>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>{zona.emoji} {zona.nombre}</div>
            <div style={{ fontSize: 12, color: '#888' }}>Avance del montaje {'—'} {pctZ}%</div>
          </div>
          <div style={{ fontSize: 28, fontWeight: 900, color: pctZ >= 100 ? C.acento : pctZ >= 50 ? C.amarillo : '#ccc' }}>{pctZ}%</div>
        </div>

        {/* Barra progreso zona */}
        <div style={{ background: '#f0f0f0', borderRadius: 6, height: 6, overflow: 'hidden', marginBottom: 14 }}>
          <div style={{ width: `${pctZ}%`, height: '100%', borderRadius: 6, background: pctZ >= 100 ? C.acento : pctZ >= 50 ? C.amarillo : '#ccc', transition: 'width 0.5s' }} />
        </div>

        {/* Filtros suicheables por tipo */}
        <div style={{ display: 'flex', gap: 6, overflowX: 'auto', marginBottom: 14, paddingBottom: 4 }}>
          {TIPOS_TRABAJO.map(t => {
            const d = avances[zonaSeleccionada]?.[t.id] || { completadas: 0, total: 0 };
            if (d.total === 0) return null;
            const activo = tipoFiltro === t.id;
            const pctT = d.total > 0 ? Math.round((d.completadas / d.total) * 100) : 0;
            return (
              <button key={t.id} onClick={() => { setTipoFiltro(t.id); setModoSeleccion(false); setPuntosSeleccionados([]); }} style={{
                flexShrink: 0, padding: '8px 12px', borderRadius: 20, cursor: 'pointer',
                fontFamily: PP, fontSize: 11, fontWeight: 700,
                background: activo ? C.acento : '#f0f0f0',
                color: activo ? C.principal : '#666', minHeight: 36,
                border: activo ? `2px solid ${C.acento}` : '2px solid transparent',
              }}>{t.label} {pctT}%</button>
            );
          })}
        </div>

        {/* Stats + botón selección múltiple */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ fontSize: 13, color: '#666', fontWeight: 500 }}>
            {tipoObj?.emoji} {datosTipo.completadas}/{datosTipo.total} completados
          </div>
          {esSupervisor && puntos.length > 0 && (
            <button onClick={() => { setModoSeleccion(!modoSeleccion); setPuntosSeleccionados([]); }} style={{
              background: modoSeleccion ? C.morado : '#f0f0f0', border: 'none',
              color: modoSeleccion ? '#fff' : '#666', borderRadius: 8,
              padding: '6px 12px', fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
            }}>{modoSeleccion ? '✕ Cancelar' : '✓ Seleccionar varios'}</button>
          )}
        </div>

        {/* Lista de puntos */}
        {datosTipo.total === 0 && (
          <div style={{ textAlign: 'center', color: '#aaa', padding: 32, fontSize: 13 }}>No hay puntos de este tipo en esta zona</div>
        )}
        {puntos.map(p => {
          const ec = estadoColor(p.estado);
          const seleccionado = puntosSeleccionados.some(x => x.num === p.num);
          return (
            <div key={p.num} onClick={() => modoSeleccion ? togglePuntoSel(p) : setPuntoSeleccionado(p)} style={{
              background: seleccionado ? `${C.acento}15` : C.principal, borderRadius: 12, padding: '14px 16px', marginBottom: 8,
              display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer',
              border: seleccionado ? `2px solid ${C.acento}` : `1px solid ${C.borde}`,
            }}>
              {modoSeleccion && (
                <div style={{
                  width: 24, height: 24, borderRadius: 6, border: seleccionado ? `2px solid ${C.acento}` : '2px solid #555',
                  background: seleccionado ? C.acento : 'transparent',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: 14, fontWeight: 700, flexShrink: 0,
                }}>{seleccionado ? '✓' : ''}</div>
              )}
              <div style={{
                width: 34, height: 34, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: p.estado === 'completado' ? C.acento : p.estado === 'en_proceso' ? C.amarillo : p.estado === 'incidente' ? C.rojo : C.morado,
                color: p.estado === 'completado' ? C.principal : '#fff', fontSize: 13, fontWeight: 700, flexShrink: 0,
              }}>{p.num}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>Punto {p.num}</div>
                {p.tecnico && <div style={{ fontSize: 11, color: C.textoSuave, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{'👤'} {p.tecnico}</div>}
                {p.hora && <div style={{ fontSize: 11, color: C.acento }}>{'✓'} {p.hora}</div>}
              </div>
              {p.foto && (
                <img src={p.foto} alt="" style={{ width: 34, height: 34, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }} />
              )}
              <div style={{
                fontSize: 10, fontWeight: 700, padding: '4px 10px', borderRadius: 12,
                background: ec.bg, color: ec.color, flexShrink: 0,
              }}>{ec.label}</div>
            </div>
          );
        })}

        {/* Barra inferior selección múltiple */}
        {modoSeleccion && puntosSeleccionados.length > 0 && (
          <div style={{
            position: 'fixed', bottom: 70, left: 0, right: 0, zIndex: 50,
            background: C.principal, borderTop: `2px solid ${C.acento}`,
            padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12,
            boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
          }}>
            <div style={{ flex: 1, color: '#fff', fontSize: 14, fontWeight: 600 }}>
              {puntosSeleccionados.length} puntos seleccionados
            </div>
            <button onClick={() => { setModalAsignar(true); setPasoAsignar(1); }} style={{
              background: C.acento, border: 'none', color: C.principal, borderRadius: 10,
              padding: '10px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
            }}>Asignar a técnico</button>
          </div>
        )}

        {/* Modal asignación múltiple */}
        {modalAsignar && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100, fontFamily: PP }}>
            <div onClick={() => setModalAsignar(false)} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)' }} />
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0, background: '#fff',
              borderRadius: '20px 20px 0 0', maxHeight: '85dvh', overflowY: 'auto',
            }}>
              <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 4px' }}>
                <div style={{ width: 40, height: 4, borderRadius: 2, background: '#ddd' }} />
              </div>
              <div style={{ padding: '8px 20px 12px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>
                  {pasoAsignar === 1 ? 'Seleccionar técnico' : pasoAsignar === 2 ? 'Asignar material' : 'Confirmar'}
                </div>
                <div style={{ fontSize: 11, color: '#888' }}>Paso {pasoAsignar}/3</div>
              </div>
              <div style={{ padding: '16px 20px 32px' }}>

                {/* PASO 1: Seleccionar técnico */}
                {pasoAsignar === 1 && (
                  <>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 10 }}>
                      Técnicos en sitio hoy ({tecnicosEnSitio.length})
                    </div>
                    {tecnicosEnSitio.length === 0 && (
                      <div style={{ textAlign: 'center', color: '#aaa', padding: 20, fontSize: 13 }}>No hay técnicos en sitio</div>
                    )}
                    {tecnicosEnSitio.map(tec => (
                      <div key={tec.id} onClick={() => { setTecnicoAsignar(tec); setPasoAsignar(2); }}
                        style={{
                          background: tecnicoAsignar?.id === tec.id ? `${C.acento}15` : '#fff',
                          borderRadius: 12, padding: '12px 14px', marginBottom: 8,
                          display: 'flex', alignItems: 'center', gap: 10,
                          border: tecnicoAsignar?.id === tec.id ? `2px solid ${C.acento}` : '1px solid #eee',
                          cursor: 'pointer',
                        }}>
                        <div style={{
                          width: 38, height: 38, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                          background: C.morado, color: '#fff', fontSize: 14, fontWeight: 700,
                        }}>{(tec.nombre || '?')[0].toUpperCase()}</div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 14, fontWeight: 600, color: C.principal }}>{tec.nombre}</div>
                          <div style={{ fontSize: 11, color: '#888' }}>
                            {tec.empresa} {'•'} {parseInt(tec.tareas_activas) || 0} activas
                          </div>
                        </div>
                        {tec.alerta_tiempo && (
                          <div className="pulso-op" style={{
                            fontSize: 10, fontWeight: 700, color: C.rojo, background: '#ffebee',
                            padding: '2px 8px', borderRadius: 8,
                          }}>{'⚠️'} 3h+</div>
                        )}
                        <div style={{ fontSize: 11, color: C.verde, fontWeight: 600 }}>
                          {parseInt(tec.completadas_hoy) || 0} {'✓'}
                        </div>
                      </div>
                    ))}
                    {/* Also show all technicos not in site */}
                    {(tecnicos || []).filter(t => !t.hora_entrada).length > 0 && (
                      <>
                        <div style={{ fontSize: 11, color: '#aaa', marginTop: 12, marginBottom: 8 }}>No en sitio</div>
                        {(tecnicos || []).filter(t => !t.hora_entrada).map(tec => (
                          <div key={tec.id} onClick={() => { setTecnicoAsignar(tec); setPasoAsignar(2); }}
                            style={{
                              background: '#f9f9f9', borderRadius: 12, padding: '10px 14px', marginBottom: 6,
                              display: 'flex', alignItems: 'center', gap: 10, border: '1px solid #eee',
                              cursor: 'pointer', opacity: 0.6,
                            }}>
                            <div style={{
                              width: 34, height: 34, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                              background: '#ddd', color: '#888', fontSize: 13, fontWeight: 700,
                            }}>{(tec.nombre || '?')[0].toUpperCase()}</div>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontSize: 13, fontWeight: 600, color: '#666' }}>{tec.nombre}</div>
                              <div style={{ fontSize: 11, color: '#aaa' }}>{tec.empresa}</div>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </>
                )}

                {/* PASO 2: Seleccionar material */}
                {pasoAsignar === 2 && (
                  <>
                    <div style={{ fontSize: 12, color: '#888', marginBottom: 12 }}>
                      Técnico: <strong style={{ color: C.principal }}>{tecnicoAsignar?.nombre}</strong>
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 10 }}>
                      Material del almacén (opcional)
                    </div>
                    {categorias.length === 0 && (
                      <div style={{ color: '#aaa', fontSize: 13, padding: 12 }}>No hay categorías de material configuradas</div>
                    )}
                    {categorias.map(cat => (
                      <div key={cat.id} style={{ marginBottom: 12 }}>
                        <div style={{ fontSize: 13, fontWeight: 700, color: C.principal, marginBottom: 6 }}>{cat.nombre}</div>
                        {(cat.items || []).map((item, idx) => {
                          const existing = materialAsignar.find(m => m.nombre === item.nombre);
                          return (
                            <div key={idx} style={{
                              display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4,
                              background: existing ? `${C.acento}10` : '#f9f9f9', borderRadius: 8, padding: '6px 10px',
                            }}>
                              <div style={{ flex: 1, fontSize: 13, color: '#333' }}>{item.nombre}</div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                <button onClick={() => {
                                  setMaterialAsignar(prev => {
                                    const ex = prev.find(m => m.nombre === item.nombre);
                                    if (ex && ex.cantidad > 1) return prev.map(m => m.nombre === item.nombre ? { ...m, cantidad: m.cantidad - 1 } : m);
                                    if (ex && ex.cantidad <= 1) return prev.filter(m => m.nombre !== item.nombre);
                                    return prev;
                                  });
                                }} style={{
                                  width: 28, height: 28, borderRadius: 6, border: '1px solid #ddd', background: '#fff',
                                  cursor: 'pointer', fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>{'−'}</button>
                                <div style={{ width: 28, textAlign: 'center', fontSize: 14, fontWeight: 700 }}>{existing?.cantidad || 0}</div>
                                <button onClick={() => {
                                  setMaterialAsignar(prev => {
                                    const ex = prev.find(m => m.nombre === item.nombre);
                                    if (ex) return prev.map(m => m.nombre === item.nombre ? { ...m, cantidad: m.cantidad + 1 } : m);
                                    return [...prev, { nombre: item.nombre, cantidad: 1 }];
                                  });
                                }} style={{
                                  width: 28, height: 28, borderRadius: 6, border: 'none', background: C.acento,
                                  cursor: 'pointer', fontSize: 14, fontWeight: 700, color: C.principal,
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>+</button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                    <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                      <button onClick={() => setPasoAsignar(1)} style={{
                        flex: 1, padding: 12, borderRadius: 10, border: '1px solid #ddd', background: '#fff',
                        color: '#666', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
                      }}>{'←'} Atrás</button>
                      <button onClick={() => setPasoAsignar(3)} style={{
                        flex: 2, padding: 12, borderRadius: 10, border: 'none',
                        background: C.acento, color: C.principal, fontSize: 13, fontWeight: 700,
                        cursor: 'pointer', fontFamily: PP,
                      }}>Siguiente {'→'}</button>
                    </div>
                  </>
                )}

                {/* PASO 3: Confirmar */}
                {pasoAsignar === 3 && (
                  <>
                    <div style={{ background: '#f5f0f7', borderRadius: 12, padding: 16, marginBottom: 16 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: C.principal, marginBottom: 8 }}>Resumen de asignación</div>
                      <div style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>
                        {'👤'} <strong>{tecnicoAsignar?.nombre}</strong> ({tecnicoAsignar?.empresa})
                      </div>
                      <div style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>
                        {'📍'} {puntosSeleccionados.length} puntos de {tipoObj?.label} en {zona.nombre}
                      </div>
                      {materialAsignar.length > 0 && (
                        <div style={{ fontSize: 13, color: '#555' }}>
                          {'📦'} Material: {materialAsignar.map(m => `${m.nombre} x${m.cantidad}`).join(', ')}
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => setPasoAsignar(2)} style={{
                        flex: 1, padding: 12, borderRadius: 10, border: '1px solid #ddd', background: '#fff',
                        color: '#666', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
                      }}>{'←'} Atrás</button>
                      <button onClick={asignarMultiples} style={{
                        flex: 2, padding: 14, borderRadius: 12, border: 'none',
                        background: C.acento, color: C.principal, fontSize: 14, fontWeight: 700,
                        cursor: 'pointer', fontFamily: PP,
                      }}>Asignar {puntosSeleccionados.length} puntos + material</button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ═══════════════════════════════════
  // NIVEL 1 - VISTA GENERAL
  // ═══════════════════════════════════
  return (
    <div style={{ padding: 16 }}>
      {/* Título */}
      <div style={{ fontSize: 18, fontWeight: 800, color: C.principal, marginBottom: 16 }}>Avance del montaje</div>

      {/* Card progreso general */}
      <div style={{
        background: C.principal, borderRadius: 16, padding: '20px', marginBottom: 16,
        color: '#fff',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <div style={{ fontSize: 52, fontWeight: 900, color: C.acento }}>{global.pct}%</div>
          <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 6, height: 8, overflow: 'hidden', margin: '8px 0' }}>
            <div style={{ width: `${global.pct}%`, height: '100%', borderRadius: 6, background: C.acento, transition: 'width 0.5s' }} />
          </div>
          <div style={{ fontSize: 12, color: C.textoSuave }}>{global.comp} de {global.total} tareas completadas</div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 10, padding: '10px 12px', textAlign: 'center' }}>
            <div style={{ fontSize: 22, fontWeight: 800 }}>{enSitio}</div>
            <div style={{ fontSize: 10, color: C.textoSuave }}>{'👥'} En sitio</div>
          </div>
          <div style={{
            background: incidentesActivos.length > 0 ? 'rgba(255,23,68,0.15)' : 'rgba(255,255,255,0.08)',
            borderRadius: 10, padding: '10px 12px', textAlign: 'center',
          }} className={incidentesActivos.length > 0 ? 'pulso-op' : ''}>
            <div style={{ fontSize: 22, fontWeight: 800, color: incidentesActivos.length > 0 ? C.rojo : '#fff' }}>{incidentesActivos.length}</div>
            <div style={{ fontSize: 10, color: incidentesActivos.length > 0 ? C.rojo : C.textoSuave }}>{'🚨'} Incidentes</div>
          </div>
        </div>
      </div>

      {/* Plano SVG interactivo */}
      <PlanoExpoSVG
        zonas={ZONAS} avances={avances} calcPorcentajeZona={calcPorcentajeZona}
        zonaConIncidente={zonaConIncidente}
        onZonaClick={(zId) => {
          setZonaSeleccionada(zId);
          setTipoFiltro(TIPOS_TRABAJO.find(t => (avances[zId]?.[t.id]?.total || 0) > 0)?.id || 'nodos');
        }}
      />

      {/* Título zonas */}
      <div style={{ fontSize: 12, fontWeight: 700, color: '#999', marginBottom: 12, letterSpacing: 1, textTransform: 'uppercase' }}>
        10 Zonas {'—'} Toca para ver detalle
      </div>

      {/* Lista de zonas */}
      {ZONAS.map((zona, idx) => {
        const pctZ = calcPorcentajeZona(zona.id);
        const tieneInc = zonaConIncidente(zona.id);
        const estadoLabel = pctZ >= 100 ? 'Completado' : pctZ > 0 ? 'En proceso' : 'Pendiente';
        const estadoColor = pctZ >= 100 ? C.acento : pctZ > 0 ? C.amarillo : '#888';
        const zc = ZONA_COLORES[idx % ZONA_COLORES.length];

        return (
          <div key={zona.id} onClick={() => {
            setZonaSeleccionada(zona.id);
            setTipoFiltro(TIPOS_TRABAJO.find(t => (avances[zona.id]?.[t.id]?.total || 0) > 0)?.id || 'nodos');
          }}
            className={tieneInc ? 'pulso-borde' : ''} style={{
              background: zc.bg, borderRadius: 14, padding: '16px', marginBottom: 10,
              cursor: 'pointer',
              borderLeft: `4px solid ${tieneInc ? C.rojo : zc.borde}`,
              border: tieneInc ? `2px solid rgba(255,23,68,0.5)` : undefined,
              borderLeftWidth: tieneInc ? 4 : 4,
            }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: zc.texto }}>{zona.emoji} {zona.nombre}</div>
                <div style={{ fontSize: 11, fontWeight: 600, color: tieneInc ? C.rojo : estadoColor, marginTop: 2 }}>
                  {tieneInc ? '🚨 Incidente activo' : estadoLabel}
                </div>
              </div>
              <div style={{ fontSize: 24, fontWeight: 900, color: zc.borde }}>{pctZ}%</div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginTop: 4 }}>
              {TIPOS_TRABAJO.map(t => {
                const d = avances[zona.id]?.[t.id] || { completadas: 0, total: 0 };
                if (d.total === 0) return null;
                const pctT = Math.round((d.completadas / d.total) * 100);
                return (
                  <div key={t.id}>
                    <div style={{ fontSize: 10, color: '#888', marginBottom: 2 }}>{t.emoji} {t.label}</div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: zc.texto, marginBottom: 2 }}>{d.completadas}/{d.total}</div>
                    <div style={{ background: 'rgba(0,0,0,0.06)', borderRadius: 2, height: 3, overflow: 'hidden' }}>
                      <div style={{ width: `${pctT}%`, height: '100%', borderRadius: 2, background: pctT >= 100 ? C.acento : zc.borde }} />
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        );
      })}
    </div>
  );
}

// ============================================
// BOTTOM SHEET PUNTO
// ============================================
function BottomSheetPunto({ punto, zona, tipo, usuario, onGuardar, onCerrar }) {
  const [estado, setEstado] = useState(punto.estado);
  const [tecnico, setTecnico] = useState(punto.tecnico || '');
  const [notas, setNotas] = useState(punto.notas || '');
  const [foto, setFoto] = useState(punto.foto || '');
  const [incDesc, setIncDesc] = useState('');
  const [urgencia, setUrgencia] = useState('media');

  const handleFoto = (e) => {
    const f = e.target.files[0]; if (!f) return;
    const r = new FileReader();
    r.onload = (ev) => setFoto(ev.target.result);
    r.readAsDataURL(f);
  };

  const puedeGuardar = () => {
    if (estado === 'completado' && !foto) return false;
    if (estado === 'incidente' && !incDesc.trim()) return false;
    return true;
  };

  const guardar = () => {
    if (!puedeGuardar()) return;
    onGuardar(estado, { tecnico, notas, foto, incDesc, urgencia });
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100, fontFamily: PP }}>
      <div onClick={onCerrar} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)' }} />
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0, background: '#fff',
        borderRadius: '20px 20px 0 0', maxHeight: '85dvh', overflowY: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 4px' }}>
          <div style={{ width: 40, height: 4, borderRadius: 2, background: '#ddd' }} />
        </div>
        <div style={{ padding: '8px 20px 12px', borderBottom: '1px solid #eee' }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>Punto {punto.num}</div>
          <div style={{ fontSize: 12, color: '#888' }}>{zona.emoji} {zona.nombre} {'—'} {tipo.emoji} {tipo.label}</div>
        </div>
        <div style={{ padding: '16px 20px 32px' }}>
          {/* Botones estado 2x2 */}
          <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8 }}>Estado</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 16 }}>
            {[
              { k: 'pendiente', icon: '⏳', label: 'Pendiente', bg: '#f5f5f5', sel: '#eee', tc: '#666' },
              { k: 'en_proceso', icon: '🔄', label: 'En proceso', bg: '#fff8e1', sel: '#fff3cd', tc: '#8d6e00' },
              { k: 'completado', icon: '✅', label: 'Completado', bg: '#e8f5e9', sel: '#c8e6c9', tc: '#2e7d32' },
              { k: 'incidente', icon: '🚨', label: 'Incidente', bg: '#ffebee', sel: C.rojo, tc: '#fff' },
            ].map(b => (
              <button key={b.k} onClick={() => setEstado(b.k)} style={{
                height: 52, borderRadius: 12, border: estado === b.k ? `2px solid ${b.k === 'incidente' ? C.rojo : C.acento}` : '2px solid #eee',
                background: estado === b.k ? (b.k === 'incidente' ? C.rojo : b.sel) : b.bg,
                color: estado === b.k && b.k === 'incidente' ? '#fff' : b.tc,
                fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: PP,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              }}>{b.icon} {b.label}</button>
            ))}
          </div>

          {/* Técnico */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>Técnico</div>
            <input value={tecnico} onChange={e => setTecnico(e.target.value)} placeholder="Técnico que lo instaló"
              style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid #ddd', fontSize: 14, fontFamily: PP, boxSizing: 'border-box', outline: 'none' }} />
          </div>

          {/* Notas */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>Notas</div>
            <textarea value={notas} onChange={e => setNotas(e.target.value)} placeholder="Notas adicionales..." rows={3}
              style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid #ddd', fontSize: 14, fontFamily: PP, resize: 'vertical', boxSizing: 'border-box', outline: 'none' }} />
          </div>

          {/* Foto */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>
              Foto {estado === 'completado' && <span style={{ color: C.rojo }}>*obligatoria</span>}
              {estado === 'incidente' && <span style={{ color: '#f97316' }}>(recomendada)</span>}
            </div>
            {foto ? (
              <div style={{ position: 'relative' }}>
                <img src={foto} alt="" style={{ width: '100%', borderRadius: 10, maxHeight: 160, objectFit: 'cover' }} />
                <label style={{ position: 'absolute', bottom: 6, right: 6, background: 'rgba(0,0,0,0.6)', color: '#fff', borderRadius: 6, padding: '4px 10px', fontSize: 11, cursor: 'pointer' }}>
                  Cambiar <input type="file" accept="image/*" capture="environment" onChange={handleFoto} style={{ display: 'none' }} />
                </label>
              </div>
            ) : (
              <label style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                background: '#fafafa', border: '2px dashed #ddd', borderRadius: 10,
                padding: '20px', cursor: 'pointer', color: '#aaa', fontSize: 13,
              }}>
                {'📷'} Tomar foto
                <input type="file" accept="image/*" capture="environment" onChange={handleFoto} style={{ display: 'none' }} />
              </label>
            )}
          </div>

          {/* Incidente */}
          {estado === 'incidente' && (
            <div style={{ background: '#fff5f5', borderRadius: 12, padding: 14, marginBottom: 12, border: '1px solid #ffcdd2' }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#c62828', marginBottom: 8 }}>{'🚨'} Reporte de incidente</div>
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>Problema <span style={{ color: C.rojo }}>*</span></div>
                <textarea value={incDesc} onChange={e => setIncDesc(e.target.value)} placeholder="Describe el problema..." rows={2}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid #ffcdd2', fontSize: 14, fontFamily: PP, resize: 'vertical', boxSizing: 'border-box', outline: 'none' }} />
              </div>
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 }}>Urgencia</div>
                <div style={{ display: 'flex', gap: 6 }}>
                  {['alta', 'media', 'baja'].map(u => (
                    <button key={u} onClick={() => setUrgencia(u)} style={{
                      flex: 1, padding: '8px', borderRadius: 8, border: urgencia === u ? `2px solid ${u === 'alta' ? C.rojo : '#999'}` : '2px solid #eee',
                      background: urgencia === u ? (u === 'alta' ? '#ffebee' : '#f5f5f5') : '#fff',
                      color: urgencia === u && u === 'alta' ? C.rojo : '#666',
                      fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: PP, textTransform: 'capitalize', minHeight: 40,
                    }}>{u}</button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Validación */}
          {estado === 'completado' && !foto && <div style={{ fontSize: 11, color: C.rojo, marginBottom: 8 }}>{'⚠️'} Se requiere foto</div>}
          {estado === 'incidente' && !incDesc.trim() && <div style={{ fontSize: 11, color: C.rojo, marginBottom: 8 }}>{'⚠️'} Describe el problema</div>}

          <button onClick={guardar} disabled={!puedeGuardar()} style={{
            width: '100%', padding: 14, borderRadius: 12, border: 'none', fontSize: 15, fontWeight: 700,
            fontFamily: PP, cursor: puedeGuardar() ? 'pointer' : 'default',
            background: !puedeGuardar() ? '#ddd' : estado === 'incidente' ? C.rojo : C.acento,
            color: !puedeGuardar() ? '#999' : estado === 'incidente' ? '#fff' : C.principal,
            opacity: puedeGuardar() ? 1 : 0.6,
          }}>{estado === 'incidente' ? '🚨 Reportar incidente' : '💾 Guardar'}</button>
        </div>
      </div>
    </div>
  );
}

// ============================================
// TAB PERSONAS (Asistencia + Usuarios + Material)
// ============================================
function TabPersonas({ esSupervisor, usuario, asistencias, horaActual, registrarAsistenciaAPI, material, registrarMaterialAPI, cambiarEstadoMaterialAPI, mostrarToast, tecnicos }) {
  const [subTab, setSubTab] = useState('asistencia');
  const [usuariosEvento, setUsuariosEvento] = useState([]);
  const [asistenciasGeo, setAsistenciasGeo] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [registrando, setRegistrando] = useState(false);

  const cargarPersonas = useCallback(async () => {
    const h = headers();
    const [uRes, aRes, asigRes] = await Promise.all([
      fetch(`${API}/api/expo/usuarios-evento`, { headers: h }).then(r => r.json()).catch(() => ({ usuarios: [] })),
      fetch(`${API}/api/expo/asistencia-hoy`, { headers: h }).then(r => r.json()).catch(() => ({ asistencias: [] })),
      fetch(`${API}/api/expo/asignaciones`, { headers: h }).then(r => r.json()).catch(() => ({ asignaciones: [] })),
    ]);
    setUsuariosEvento(uRes.usuarios || []);
    setAsistenciasGeo(aRes.asistencias || []);
    setAsignaciones(asigRes.asignaciones || []);
  }, []);

  useEffect(() => { cargarPersonas(); }, [cargarPersonas]);

  const registrarGeo = async (tipo) => {
    setRegistrando(true);
    try {
      const ubi = await obtenerUbicacion();
      const res = await fetch(`${API}/api/expo/asistencia-geo`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify({ usuario_id: usuario?.id, tipo, latitud: ubi.latitud, longitud: ubi.longitud }),
      });
      const data = await res.json();
      if (!res.ok) { mostrarToast(data.error || 'Error'); setRegistrando(false); return; }
      mostrarToast(tipo === 'entrada' ? `Llegada registrada${data.dentroDeZona ? ' (en zona)' : ''}` : 'Salida registrada');
      cargarPersonas();
    } catch (e) { mostrarToast(e.message || 'Error de ubicación'); }
    setRegistrando(false);
  };

  const registrarManualGeo = async (nombre, empresa) => {
    try {
      await fetch(`${API}/api/expo/asistencia-geo`, {
        method: 'POST', headers: headers(),
        body: JSON.stringify({ nombre_manual: nombre, empresa_manual: empresa, tipo: 'entrada', registrado_manualmente: true, registrado_por: usuario?.id }),
      });
      mostrarToast('Llegada registrada');
      cargarPersonas();
    } catch (e) { mostrarToast('Error'); }
  };

  const enSitio = asistenciasGeo.filter(a => a.tipo === 'entrada').length;

  const tabs = [
    { id: 'asistencia', label: 'Asistencia', emoji: '✅' },
    { id: 'usuarios', label: 'Usuarios', emoji: '👤' },
    { id: 'material', label: 'Material', emoji: '📦' },
  ];

  return (
    <div style={{ padding: 16 }}>
      {/* Sub-tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setSubTab(t.id)} style={{
            flex: 1, padding: '10px 8px', borderRadius: 10, border: 'none', cursor: 'pointer', fontFamily: PP,
            background: subTab === t.id ? C.acento : '#f0f0f0',
            color: subTab === t.id ? C.principal : '#666', fontSize: 12, fontWeight: 600,
          }}>{t.emoji} {t.label}</button>
        ))}
      </div>

      {/* Sub-tab: Asistencia */}
      {subTab === 'asistencia' && (
        esSupervisor ? (
          <SubAsistenciaSupervisor
            asistencias={asistenciasGeo} asignaciones={asignaciones}
            enSitio={enSitio} usuario={usuario} registrarManualGeo={registrarManualGeo}
            cargarPersonas={cargarPersonas} mostrarToast={mostrarToast} />
        ) : (
          <SubAsistenciaTecnico
            asistencias={asistenciasGeo} asignaciones={asignaciones}
            usuario={usuario} horaActual={horaActual}
            registrarGeo={registrarGeo} registrando={registrando} />
        )
      )}

      {/* Sub-tab: Usuarios con tracking */}
      {subTab === 'usuarios' && (
        <UsuariosConTracking
          usuariosEvento={usuariosEvento} tecnicos={tecnicos || []}
          esSupervisor={esSupervisor}
        />
      )}

      {/* Sub-tab: Material */}
      {subTab === 'material' && (
        <TabMaterial esSupervisor={esSupervisor} usuario={usuario} material={material}
          registrarMaterialAPI={registrarMaterialAPI} cambiarEstadoMaterialAPI={cambiarEstadoMaterialAPI}
          mostrarToast={mostrarToast} />
      )}
    </div>
  );
}

// ============================================
// USUARIOS CON TRACKING
// ============================================
function UsuariosConTracking({ usuariosEvento, tecnicos, esSupervisor }) {
  const [perfilAbierto, setPerfilAbierto] = useState(null);
  const [pendientes, setPendientes] = useState([]);

  useEffect(() => {
    if (esSupervisor) {
      fetch(`${API}/api/expo/usuarios-pendientes`, { headers: headers() })
        .then(r => r.json()).then(d => setPendientes(d.pendientes || [])).catch(() => {});
    }
  }, [esSupervisor]);

  const aprobarUsuario = async (aprobacionId) => {
    try {
      await fetch(`${API}/api/expo/aprobar-usuario/${aprobacionId}`, {
        method: 'PUT', headers: headers(), body: JSON.stringify({ aprobado_por: 'supervisor' }),
      });
      setPendientes(prev => prev.filter(p => p.aprobacion_id !== aprobacionId));
    } catch {}
  };

  const rechazarUsuario = async (aprobacionId) => {
    try {
      await fetch(`${API}/api/expo/rechazar-usuario/${aprobacionId}`, {
        method: 'PUT', headers: headers(),
      });
      setPendientes(prev => prev.filter(p => p.aprobacion_id !== aprobacionId));
    } catch {}
  };

  // Merge usuario data with tecnicos data
  const usuarios = usuariosEvento.map(u => {
    const tec = tecnicos.find(t => String(t.id) === String(u.id));
    return { ...u, ...tec };
  });

  const coloresEmpresa = {};
  const paleta = ['#9b59b6', '#3498db', '#e67e22', '#2ecc71', '#e74c3c', '#1abc9c', '#f39c12', '#8e44ad'];
  let ci = 0;
  usuarios.forEach(u => {
    const emp = (u.empresa || 'Otro').toLowerCase();
    if (!coloresEmpresa[emp]) { coloresEmpresa[emp] = paleta[ci % paleta.length]; ci++; }
  });

  return (
    <div>
      {/* Pendientes de aprobación */}
      {esSupervisor && pendientes.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.rojo, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>
            🔔 Pendientes de aprobación ({pendientes.length})
          </div>
          {pendientes.map(p => (
            <div key={p.aprobacion_id} style={{
              background: '#fff8e1', borderRadius: 12, padding: 14, marginBottom: 8,
              border: '1px solid #ffe082',
            }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.principal }}>{p.nombre}</div>
              <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{p.empresa} · Solicitó acceso al montaje</div>
              <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                <button onClick={() => aprobarUsuario(p.aprobacion_id)} style={{
                  flex: 1, padding: '8px', borderRadius: 8, border: 'none', cursor: 'pointer',
                  background: C.acento, color: C.principal, fontSize: 12, fontWeight: 700, fontFamily: PP,
                }}>✅ Aprobar</button>
                <button onClick={() => rechazarUsuario(p.aprobacion_id)} style={{
                  flex: 1, padding: '8px', borderRadius: 8, border: 'none', cursor: 'pointer',
                  background: '#ffebee', color: C.rojo, fontSize: 12, fontWeight: 700, fontFamily: PP,
                }}>✗ Rechazar</button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ fontSize: 14, fontWeight: 700, color: C.principal, marginBottom: 12 }}>
        {usuarios.length} personas registradas
      </div>
      {usuarios.map(u => {
        const enSitio = parseInt(u.entradas_hoy) > 0;
        const empColor = coloresEmpresa[(u.empresa || 'Otro').toLowerCase()] || '#888';
        const alertaTiempo = u.alerta_tiempo;
        const tareasActivas = parseInt(u.tareas_activas) || 0;
        const completadasHoy = parseInt(u.completadas_hoy) || 0;
        const tareaActual = u.tarea_actual || '';

        return (
          <div key={u.id} onClick={() => setPerfilAbierto(perfilAbierto === u.id ? null : u.id)} style={{
            background: '#fff', borderRadius: 12, padding: '12px 14px', marginBottom: 8,
            border: alertaTiempo ? `2px solid ${C.rojo}` : '1px solid #eee',
            cursor: 'pointer',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{
                width: 40, height: 40, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: empColor, color: '#fff', fontSize: 15, fontWeight: 700, flexShrink: 0,
              }}>{(u.nombre || '?').split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: C.principal, display: 'flex', alignItems: 'center', gap: 6 }}>
                  {u.nombre}
                  {alertaTiempo && (
                    <span className="pulso-op" style={{
                      fontSize: 9, fontWeight: 700, color: C.rojo, background: '#ffebee',
                      padding: '1px 6px', borderRadius: 6,
                    }}>{'⚠️'} 3h+</span>
                  )}
                </div>
                <div style={{ fontSize: 11, color: '#888', display: 'flex', gap: 4, alignItems: 'center', flexWrap: 'wrap' }}>
                  {u.empresa}
                  <span style={{ fontSize: 9, padding: '1px 6px', borderRadius: 4, fontWeight: 700,
                    background: u.es_externo ? '#eee' : `${C.morado}22`, color: u.es_externo ? '#888' : C.morado,
                  }}>{u.es_externo ? 'Externo' : 'Beep'}</span>
                </div>
                {tareaActual && (
                  <div style={{ fontSize: 10, color: '#666', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {'🔄'} {tareaActual.length > 40 ? tareaActual.slice(0, 38) + '..' : tareaActual}
                  </div>
                )}
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                {enSitio
                  ? <div style={{ fontSize: 10, fontWeight: 700, color: C.verde, background: `${C.verde}15`, padding: '2px 8px', borderRadius: 6 }}>{'✅'} En sitio</div>
                  : <div style={{ fontSize: 10, color: '#aaa' }}>Sin registro</div>
                }
                {completadasHoy > 0 && (
                  <div style={{ fontSize: 11, fontWeight: 700, color: C.verde, marginTop: 2 }}>{completadasHoy} {'✓'}</div>
                )}
              </div>
            </div>

            {/* Panel detalle expandible */}
            {perfilAbierto === u.id && (
              <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #eee' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 8 }}>
                  <div style={{ textAlign: 'center', background: `${C.verde}10`, borderRadius: 8, padding: 8 }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: C.verde }}>{completadasHoy}</div>
                    <div style={{ fontSize: 9, color: '#888' }}>Completadas</div>
                  </div>
                  <div style={{ textAlign: 'center', background: '#fff8e1', borderRadius: 8, padding: 8 }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: '#e65100' }}>{tareasActivas}</div>
                    <div style={{ fontSize: 9, color: '#888' }}>En proceso</div>
                  </div>
                  <div style={{ textAlign: 'center', background: '#f5f5f5', borderRadius: 8, padding: 8 }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: '#888' }}>{parseInt(u.pendientes) || 0}</div>
                    <div style={{ fontSize: 9, color: '#888' }}>Pendientes</div>
                  </div>
                </div>
                {parseInt(u.items_asignados) > 0 && (
                  <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>
                    {'📦'} {u.items_asignados} items de material asignados
                  </div>
                )}
                {u.hora_entrada && (
                  <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>
                    {'📍'} Entrada: {new Date(u.hora_entrada).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                )}
                {u.minutos_en_tarea != null && u.minutos_en_tarea > 0 && (
                  <div style={{ fontSize: 11, color: alertaTiempo ? C.rojo : '#888', marginTop: 4, fontWeight: alertaTiempo ? 700 : 400 }}>
                    {'⏱️'} {Math.floor(u.minutos_en_tarea / 60)}h {u.minutos_en_tarea % 60}min en tarea actual
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ============================================
// SUB: ASISTENCIA SUPERVISOR
// ============================================
function SubAsistenciaSupervisor({ asistencias, asignaciones, enSitio, usuario, registrarManualGeo, cargarPersonas, mostrarToast }) {
  const [modal, setModal] = useState(false);
  const [nombre, setNombre] = useState('');
  const [empresa, setEmpresa] = useState('');

  const sinRegistrar = asignaciones.filter(a =>
    !asistencias.some(as => String(as.usuario_id) === String(a.usuario_id) && as.tipo === 'entrada')
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>Asistencia hoy</div>
          <div style={{ fontSize: 12, color: '#888' }}>{enSitio} personas en sitio</div>
        </div>
        <button onClick={() => setModal(true)} style={{
          background: C.acento, border: 'none', color: C.principal, borderRadius: 10,
          padding: '10px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
        }}>{'➕'} Llegada</button>
      </div>

      {/* Sin registrar */}
      {sinRegistrar.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#e65100', marginBottom: 8 }}>Sin registrar hoy ({sinRegistrar.length})</div>
          {sinRegistrar.map(a => (
            <div key={a.id} style={{
              background: '#fff8e1', borderRadius: 10, padding: '10px 12px', marginBottom: 6,
              display: 'flex', alignItems: 'center', gap: 10, border: '1px solid #ffe082',
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{a.usuario_nombre || a.nombre_externo}</div>
                <div style={{ fontSize: 11, color: '#888' }}>{a.punto_nombre} {'•'} {a.hora_programada?.slice(0, 5)}</div>
              </div>
              <div style={{ fontSize: 10, fontWeight: 700, color: C.rojo, padding: '3px 8px', background: '#ffebee', borderRadius: 6 }}>Sin registrar</div>
            </div>
          ))}
        </div>
      )}

      {/* Lista de asistencias */}
      {asistencias.length === 0 && sinRegistrar.length === 0 && (
        <div style={{ textAlign: 'center', color: '#aaa', padding: 32, fontSize: 13 }}>No hay registros aún</div>
      )}
      {asistencias.map(a => (
        <div key={a.id} style={{
          background: '#fff', borderRadius: 12, padding: '12px 14px', marginBottom: 8,
          display: 'flex', alignItems: 'center', gap: 10, border: '1px solid #eee',
        }}>
          <div style={{
            width: 34, height: 34, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: a.tipo === 'entrada' ? `${C.verde}22` : '#eee',
            color: a.tipo === 'entrada' ? C.verde : '#888', fontSize: 13, fontWeight: 700,
          }}>{(a.usuario_nombre || a.nombre_manual || '?')[0].toUpperCase()}</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: C.principal }}>{a.usuario_nombre || a.nombre_manual}</div>
            <div style={{ fontSize: 11, color: '#888', display: 'flex', gap: 4, alignItems: 'center', flexWrap: 'wrap' }}>
              {a.empresa || a.empresa_manual || ''}
              {a.dentro_de_zona && <span style={{ fontSize: 9, color: C.verde }}>{'📍'}</span>}
              {a.registrado_manualmente && <span style={{ fontSize: 9, color: '#888' }}>{'👤'} manual</span>}
              {a.minutos_diferencia > 5 && <span style={{ fontSize: 9, fontWeight: 700, color: C.rojo }}>{a.minutos_diferencia} min tarde</span>}
            </div>
          </div>
          <div style={{ fontSize: 11, color: '#888' }}>
            {a.tipo === 'entrada' ? '✅' : '🚪'} {new Date(a.creado_en).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
      ))}

      {modal && (
        <ModalSheet onCerrar={() => setModal(false)} titulo="Registrar llegada">
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Nombre</div>
            <input value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre completo" style={inp} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={lbl}>Empresa</div>
            <input value={empresa} onChange={e => setEmpresa(e.target.value)} placeholder="Empresa (opcional)" style={inp} />
          </div>
          <button onClick={async () => { if (!nombre.trim()) return; await registrarManualGeo(nombre.trim(), empresa.trim()); setModal(false); setNombre(''); setEmpresa(''); }} style={{
            ...btn, background: nombre.trim() ? C.acento : '#ddd', color: nombre.trim() ? C.principal : '#999',
          }}>{'✅'} Registrar llegada</button>
        </ModalSheet>
      )}
    </div>
  );
}

// ============================================
// SUB: ASISTENCIA TÉCNICO
// ============================================
function SubAsistenciaTecnico({ asistencias, asignaciones, usuario, horaActual, registrarGeo, registrando }) {
  const miAsignacion = asignaciones.find(a => String(a.usuario_id) === String(usuario?.id));
  const miEntrada = asistencias.find(a => String(a.usuario_id) === String(usuario?.id) && a.tipo === 'entrada');
  const miSalida = asistencias.find(a => String(a.usuario_id) === String(usuario?.id) && a.tipo === 'salida');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, minHeight: '50dvh', justifyContent: 'center' }}>
      <div style={{ fontSize: 40, fontWeight: 900, color: C.principal }}>
        {horaActual.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
      </div>

      {miAsignacion ? (
        <div style={{ background: '#f5f0f7', borderRadius: 14, padding: 16, textAlign: 'center', width: '100%', border: `1px solid ${C.borde}` }}>
          <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>{'📍'} Preséntate en:</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>{miAsignacion.punto_nombre}</div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
            {'⏰'} {miAsignacion.hora_programada?.slice(0, 5)} {'•'} {'📏'} Radio: {miAsignacion.radio_metros}m
          </div>
        </div>
      ) : (
        <div style={{ background: '#fff8e1', borderRadius: 14, padding: 16, textAlign: 'center', width: '100%', border: '1px solid #ffe082' }}>
          <div style={{ fontSize: 13, color: '#888' }}>No tienes asignación para hoy.</div>
          <div style={{ fontSize: 12, color: '#aaa', marginTop: 4 }}>Contacta a tu supervisor.</div>
        </div>
      )}

      {miEntrada && (
        <div style={{ fontSize: 12, color: C.verde, background: `${C.verde}15`, padding: '8px 16px', borderRadius: 8 }}>
          {'✅'} Entrada registrada: {new Date(miEntrada.creado_en).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
          {miEntrada.dentro_de_zona && ' (en zona)'}
        </div>
      )}

      {!miEntrada && (
        <button onClick={() => registrarGeo('entrada')} disabled={registrando} style={{
          width: '100%', padding: '22px', borderRadius: 16, border: 'none', cursor: registrando ? 'default' : 'pointer',
          background: registrando ? '#ddd' : C.acento, color: registrando ? '#888' : C.principal,
          fontSize: 18, fontWeight: 800, fontFamily: PP,
        }}>
          {registrando ? 'Obteniendo ubicación...' : '✅ REGISTRAR MI LLEGADA'}
          {!registrando && <div style={{ fontSize: 11, fontWeight: 400, marginTop: 2 }}>Se verificará tu ubicación</div>}
        </button>
      )}

      {miEntrada && !miSalida && (
        <button onClick={() => registrarGeo('salida')} disabled={registrando} style={{
          width: '100%', padding: '18px', borderRadius: 16, border: 'none', cursor: 'pointer',
          background: C.card, color: '#fff', fontSize: 16, fontWeight: 700, fontFamily: PP,
        }}>{'🚪'} REGISTRAR SALIDA</button>
      )}
    </div>
  );
}

// ============================================
// TAB ALMACÉN
// ============================================
const CATEGORIAS_RAPIDAS = [
  { nombre: 'Equipo personal', items: ['Chaleco', 'Casco', 'Radio'] },
  { nombre: 'Herramientas', items: ['Multímetro', 'Destornilladores', 'Pinzas'] },
  { nombre: 'Equipos Beep', items: ['Laptop', 'Tablet', 'Cámara'] },
  { nombre: 'Consumibles', items: ['Cable UTP', 'Conectores RJ45', 'Cinta'] },
];

function TabAlmacen({ esSupervisor, usuario, mostrarToast }) {
  const [categorias, setCategorias] = useState([]);
  const [asignacionesMat, setAsignacionesMat] = useState([]);
  const [modalCategoria, setModalCategoria] = useState(false);
  const [modalAsignar, setModalAsignar] = useState(false);
  const [catForm, setCatForm] = useState({ nombre: '', descripcion: '', items: [{ nombre: '', cantidad: 1 }] });
  const [asigForm, setAsigForm] = useState({ kit_id: '', nombre_externo: '', empresa_externo: '', notas: '' });
  const [usuarios, setUsuarios] = useState([]);

  const cargarDatos = useCallback(async () => {
    const h = headers();
    const [kRes, aRes, uRes] = await Promise.all([
      fetch(`${API}/api/expo/kits`, { headers: h }).then(r => r.json()).catch(() => ({ kits: [] })),
      fetch(`${API}/api/expo/material-asignado`, { headers: h }).then(r => r.json()).catch(() => ({ asignaciones: [] })),
      fetch(`${API}/api/expo/usuarios-evento`, { headers: h }).then(r => r.json()).catch(() => ({ usuarios: [] })),
    ]);
    setCategorias(kRes.kits || []);
    setAsignacionesMat(aRes.asignaciones || []);
    setUsuarios(uRes.usuarios || []);
  }, []);

  useEffect(() => { cargarDatos(); }, [cargarDatos]);

  const crearCategoria = async () => {
    if (!catForm.nombre.trim()) return;
    const items = catForm.items.filter(i => i.nombre.trim());
    await fetch(`${API}/api/expo/kits`, { method: 'POST', headers: headers(),
      body: JSON.stringify({ nombre: catForm.nombre, descripcion: catForm.descripcion, items }) });
    setModalCategoria(false); setCatForm({ nombre: '', descripcion: '', items: [{ nombre: '', cantidad: 1 }] });
    mostrarToast('Categoría creada'); cargarDatos();
  };

  const asignarEquipo = async () => {
    if (!asigForm.kit_id || !asigForm.nombre_externo.trim()) return;
    const cat = categorias.find(k => k.id === parseInt(asigForm.kit_id));
    await fetch(`${API}/api/expo/material-asignado`, { method: 'POST', headers: headers(),
      body: JSON.stringify({
        kit_id: asigForm.kit_id, nombre_externo: asigForm.nombre_externo,
        empresa_externo: asigForm.empresa_externo, items_asignados: cat?.items || [],
        asignado_por: usuario?.id, notas: asigForm.notas,
      }) });
    setModalAsignar(false); setAsigForm({ kit_id: '', nombre_externo: '', empresa_externo: '', notas: '' });
    mostrarToast('Equipo asignado'); cargarDatos();
  };

  const devolver = async (id) => {
    await fetch(`${API}/api/expo/material-asignado/${id}/devolver`, { method: 'PUT', headers: headers(),
      body: JSON.stringify({}) });
    mostrarToast('Devolución registrada'); cargarDatos();
  };

  const miMaterial = esSupervisor ? asignacionesMat : asignacionesMat.filter(a =>
    String(a.usuario_id) === String(usuario?.id) || (a.nombre_externo || '').toLowerCase() === (usuario?.nombre || '').toLowerCase()
  );

  const addItem = () => setCatForm(p => ({ ...p, items: [...p.items, { nombre: '', cantidad: 1 }] }));

  const abrirConRapida = (cat) => {
    setCatForm({ nombre: cat.nombre, descripcion: '', items: cat.items.map(i => ({ nombre: i, cantidad: 1 })) });
    setModalCategoria(true);
  };

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>Almacén</div>
        {esSupervisor && (
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={() => { setCatForm({ nombre: '', descripcion: '', items: [{ nombre: '', cantidad: 1 }] }); setModalCategoria(true); }} style={{
              background: C.acento, border: 'none', color: C.principal, borderRadius: 8,
              padding: '8px 12px', fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
            }}>{'📦'} Nueva categoría</button>
            <button onClick={() => setModalAsignar(true)} style={{
              background: C.morado, border: 'none', color: '#fff', borderRadius: 8,
              padding: '8px 12px', fontSize: 11, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
            }}>{'➕'} Asignar equipo</button>
          </div>
        )}
      </div>

      {/* Categorías rápidas */}
      {esSupervisor && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: '#999', width: '100%' }}>Categorías rápidas:</div>
          {CATEGORIAS_RAPIDAS.map(cat => (
            <button key={cat.nombre} onClick={() => abrirConRapida(cat)} style={{
              background: '#f0f0f0', border: '1px solid #ddd',
              borderRadius: 20, padding: '4px 12px',
              fontSize: 11, cursor: 'pointer', fontFamily: PP,
            }}>+ {cat.nombre}</button>
          ))}
        </div>
      )}

      {/* Inventario general mejorado */}
      {categorias.length > 0 && esSupervisor && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>
            Inventario general
          </div>
          {categorias.map(k => {
            const items = k.items || [];
            const totalItems = items.reduce((s, it) => s + (it.cantidad || 1), 0);
            const asignadosDeEsta = asignacionesMat.filter(a => a.kit_id === k.id && a.estado !== 'devuelto').length;
            return (
              <div key={k.id} style={{
                background: '#f5f0f7', borderRadius: 12, padding: 14, marginBottom: 10,
                border: `1px solid ${C.borde}`,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: C.principal }}>{k.nombre}</div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div style={{ fontSize: 10, background: `${C.acento}22`, color: C.acento, padding: '2px 8px', borderRadius: 6, fontWeight: 700 }}>
                      {totalItems} total
                    </div>
                    <div style={{ fontSize: 10, background: `${C.amarillo}22`, color: '#8d6e00', padding: '2px 8px', borderRadius: 6, fontWeight: 700 }}>
                      {asignadosDeEsta} asignados
                    </div>
                  </div>
                </div>
                {items.map((it, idx) => (
                  <div key={idx} style={{
                    display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0',
                    borderTop: idx > 0 ? '1px solid rgba(0,0,0,0.05)' : 'none',
                  }}>
                    <div style={{
                      width: 32, height: 32, borderRadius: 6, background: '#e0d4e8',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 14, flexShrink: 0,
                    }}>{'📦'}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: C.principal }}>{it.nombre}</div>
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#555' }}>x{it.cantidad || 1}</div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      )}

      {/* Asignaciones */}
      {miMaterial.length === 0 && <div style={{ textAlign: 'center', color: '#aaa', padding: 32, fontSize: 13 }}>No hay equipo asignado</div>}
      {miMaterial.map(a => (
        <div key={a.id} style={{ background: '#fff', borderRadius: 12, padding: '14px', marginBottom: 8, border: '1px solid #eee' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.principal }}>{a.usuario_nombre || a.nombre_externo}</div>
              <div style={{ fontSize: 11, color: '#888' }}>{a.kit_nombre} {'•'} {a.empresa || a.empresa_externo}</div>
            </div>
            <div style={{
              fontSize: 10, fontWeight: 700, padding: '4px 10px', borderRadius: 12, height: 'fit-content',
              background: a.estado === 'devuelto' ? '#eee' : `${C.amarillo}22`,
              color: a.estado === 'devuelto' ? '#888' : '#8d6e00',
              textTransform: 'capitalize',
            }}>{a.estado}</div>
          </div>
          <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>
            {(a.items_asignados || a.kit_items || []).map((it, i) => (
              <span key={i}>{it.nombre} x{it.cantidad}{i < (a.items_asignados || a.kit_items || []).length - 1 ? ', ' : ''}</span>
            ))}
          </div>
          {esSupervisor && a.estado !== 'devuelto' && (
            <button onClick={() => devolver(a.id)} style={{
              padding: '7px 12px', borderRadius: 8, border: 'none', cursor: 'pointer',
              background: `${C.verde}22`, color: C.verde, fontSize: 11, fontWeight: 600, fontFamily: PP,
            }}>{'✅'} Registrar devolución</button>
          )}
        </div>
      ))}

      {/* Modal Nueva Categoría */}
      {modalCategoria && (
        <ModalSheet onCerrar={() => setModalCategoria(false)} titulo="Nueva categoría">
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Categoría</div>
            <input value={catForm.nombre} onChange={e => setCatForm(p => ({ ...p, nombre: e.target.value }))} placeholder="Ej: Equipo personal, Herramientas..." style={inp} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Artículos</div>
            {catForm.items.map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
                <input value={item.nombre} onChange={e => {
                  const items = [...catForm.items]; items[i].nombre = e.target.value; setCatForm(p => ({ ...p, items }));
                }} placeholder="Nombre del artículo" style={{ ...inp, flex: 1 }} />
                <input type="number" min="1" value={item.cantidad} onChange={e => {
                  const items = [...catForm.items]; items[i].cantidad = parseInt(e.target.value) || 1; setCatForm(p => ({ ...p, items }));
                }} style={{ ...inp, width: 60 }} />
              </div>
            ))}
            <button onClick={addItem} style={{ background: 'none', border: '1px dashed #ccc', borderRadius: 8, padding: '8px', width: '100%', color: '#888', fontSize: 12, cursor: 'pointer', fontFamily: PP }}>+ Agregar artículo</button>
          </div>
          <button onClick={crearCategoria} style={{ ...btn, background: catForm.nombre.trim() ? C.acento : '#ddd', color: catForm.nombre.trim() ? C.principal : '#999' }}>{'📦'} Crear categoría</button>
        </ModalSheet>
      )}

      {/* Modal Asignar Equipo */}
      {modalAsignar && (
        <ModalSheet onCerrar={() => setModalAsignar(false)} titulo="Asignar equipo a persona">
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Categoría</div>
            <select value={asigForm.kit_id} onChange={e => setAsigForm(p => ({ ...p, kit_id: e.target.value }))} style={{ ...inp, appearance: 'auto' }}>
              <option value="">Seleccionar categoría...</option>
              {categorias.map(k => <option key={k.id} value={k.id}>{k.nombre}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Persona</div>
            <input value={asigForm.nombre_externo} onChange={e => setAsigForm(p => ({ ...p, nombre_externo: e.target.value }))} placeholder="Nombre" style={inp} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Empresa</div>
            <input value={asigForm.empresa_externo} onChange={e => setAsigForm(p => ({ ...p, empresa_externo: e.target.value }))} placeholder="Empresa" style={inp} />
          </div>
          <button onClick={asignarEquipo} style={{
            ...btn, background: (asigForm.kit_id && asigForm.nombre_externo.trim()) ? C.acento : '#ddd',
            color: (asigForm.kit_id && asigForm.nombre_externo.trim()) ? C.principal : '#999',
          }}>{'➕'} Asignar equipo</button>
        </ModalSheet>
      )}
    </div>
  );
}

// ============================================
// TAB ASISTENCIA
// ============================================
function TabAsistencia({ esSupervisor, usuario, asistencias, horaActual, registrarAsistenciaAPI, mostrarToast }) {
  const [filtro, setFiltro] = useState('todos');
  const [modal, setModal] = useState(false);
  const [nombre, setNombre] = useState('');
  const [empresa, setEmpresa] = useState('');

  const registrar = async (tipo) => {
    await registrarAsistenciaAPI(tipo);
    mostrarToast(tipo === 'entrada' ? 'Entrada registrada' : 'Salida registrada');
  };

  const registrarManual = async () => {
    if (!nombre.trim()) return;
    await registrarAsistenciaAPI('entrada', { manual: true, nombre: nombre.trim(), empresa: empresa.trim() || 'Externo' });
    setModal(false); setNombre(''); setEmpresa('');
    mostrarToast('Llegada registrada');
  };

  const filtradas = filtro === 'todos' ? asistencias : filtro === 'beep' ? asistencias.filter(a => !a.es_externo) : asistencias.filter(a => a.es_externo);
  const enSitio = asistencias.filter(a => a.tipo === 'entrada').length;

  if (!esSupervisor) {
    const ultimo = asistencias.filter(a => String(a.usuario_id) === String(usuario?.id)).sort((a, b) => new Date(b.creado_en) - new Date(a.creado_en))[0];
    return (
      <div style={{ padding: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, minHeight: '65dvh', justifyContent: 'center' }}>
        <div style={{ fontSize: 44, fontWeight: 900, color: C.principal }}>
          {horaActual.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </div>
        <div style={{ fontSize: 13, color: '#888' }}>
          {horaActual.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' })}
        </div>
        {ultimo && (
          <div style={{ fontSize: 12, color: '#888', background: '#f5f5f5', padding: '8px 16px', borderRadius: 8 }}>
            Último registro: {ultimo.tipo === 'entrada' ? '✅ Entrada' : '🚪 Salida'} {new Date(ultimo.creado_en).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
          </div>
        )}
        <button onClick={() => registrar('entrada')} style={{
          width: '100%', padding: '22px', borderRadius: 16, border: 'none', cursor: 'pointer',
          background: C.acento, color: C.principal, fontSize: 18, fontWeight: 800, fontFamily: PP,
        }}>
          {'✅'} REGISTRAR ENTRADA
          <div style={{ fontSize: 12, fontWeight: 400, marginTop: 2 }}>Toca para marcar</div>
        </button>
        <button onClick={() => registrar('salida')} style={{
          width: '100%', padding: '22px', borderRadius: 16, border: 'none', cursor: 'pointer',
          background: C.card, color: '#fff', fontSize: 18, fontWeight: 800, fontFamily: PP,
        }}>{'🚪'} REGISTRAR SALIDA</button>
      </div>
    );
  }

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>Asistencia hoy</div>
          <div style={{ fontSize: 12, color: '#888' }}>{enSitio} personas en sitio</div>
        </div>
        <button onClick={() => setModal(true)} style={{
          background: C.acento, border: 'none', color: C.principal, borderRadius: 10,
          padding: '10px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
        }}>{'➕'} Llegada manual</button>
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 14 }}>
        {['todos', 'beep', 'externos'].map(f => (
          <button key={f} onClick={() => setFiltro(f)} style={{
            padding: '7px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontFamily: PP,
            background: filtro === f ? C.acento : '#f0f0f0',
            color: filtro === f ? C.principal : '#888', fontSize: 12, fontWeight: 600, textTransform: 'capitalize',
          }}>{f}</button>
        ))}
      </div>

      {filtradas.length === 0 && <div style={{ textAlign: 'center', color: '#aaa', padding: 32, fontSize: 13 }}>No hay registros aún</div>}
      {filtradas.map(a => (
        <div key={a.id} style={{
          background: '#fff', borderRadius: 12, padding: '12px 14px', marginBottom: 8,
          display: 'flex', alignItems: 'center', gap: 10, border: '1px solid #eee',
        }}>
          <div style={{
            width: 34, height: 34, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: a.es_externo ? '#eee' : C.morado, color: a.es_externo ? '#666' : '#fff',
            fontSize: 13, fontWeight: 700,
          }}>{(a.nombre || '?')[0].toUpperCase()}</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: C.principal }}>{a.nombre}</div>
            <div style={{ fontSize: 11, color: '#888', display: 'flex', alignItems: 'center', gap: 4 }}>
              {a.empresa}
              <span style={{
                fontSize: 9, padding: '1px 6px', borderRadius: 4, fontWeight: 700,
                background: a.es_externo ? '#eee' : `${C.morado}22`, color: a.es_externo ? '#888' : C.morado,
              }}>{a.es_externo ? 'Externo' : 'Beep'}</span>
            </div>
          </div>
          <div style={{ fontSize: 12, color: '#888' }}>
            {new Date(a.creado_en).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
      ))}

      {modal && (
        <ModalSheet onCerrar={() => setModal(false)} titulo="Registrar llegada manual">
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Nombre</div>
            <input value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre completo" style={inp} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={lbl}>Empresa</div>
            <input value={empresa} onChange={e => setEmpresa(e.target.value)} placeholder="Empresa (opcional)" style={inp} />
          </div>
          <button onClick={registrarManual} disabled={!nombre.trim()} style={{
            ...btn, background: nombre.trim() ? C.acento : '#ddd', color: nombre.trim() ? C.principal : '#999',
          }}>{'✅'} Registrar llegada</button>
        </ModalSheet>
      )}
    </div>
  );
}

// ============================================
// TAB MATERIAL
// ============================================
function TabMaterial({ esSupervisor, usuario, material, registrarMaterialAPI, cambiarEstadoMaterialAPI, mostrarToast }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ tecnico: '', tipo: 'Material', descripcion: '', cantidad: 1, foto: '' });

  const miMaterial = esSupervisor ? material : material.filter(m => (m.tecnico_nombre || m.tecnico || '').toLowerCase() === (usuario?.nombre || '').toLowerCase());
  const entregados = miMaterial.filter(m => m.estado === 'entregado').length;
  const instalados = miMaterial.filter(m => m.estado === 'instalado').length;

  const guardar = async () => {
    if (!form.tecnico.trim() || !form.descripcion.trim()) return;
    await registrarMaterialAPI({
      tecnico_nombre: form.tecnico, tipo: form.tipo, descripcion: form.descripcion,
      cantidad: form.cantidad, foto_url: form.foto, entregado_por: usuario?.nombre || 'Supervisor',
    });
    setModal(false); setForm({ tecnico: '', tipo: 'Material', descripcion: '', cantidad: 1, foto: '' });
    mostrarToast('Material registrado');
  };

  const cambiarEstado = async (id, est) => {
    await cambiarEstadoMaterialAPI(id, est);
    mostrarToast('Estado actualizado');
  };

  const handleFoto = (e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = ev => setForm(p => ({ ...p, foto: ev.target.result })); r.readAsDataURL(f); };
  const ec = { entregado: C.amarillo, instalado: C.verde, devuelto: '#aaa' };

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>Material y herramientas</div>
        {esSupervisor && <button onClick={() => setModal(true)} style={{
          background: C.acento, border: 'none', color: C.principal, borderRadius: 10,
          padding: '10px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
        }}>{'➕'} Entregar</button>}
      </div>

      <div style={{
        background: C.card, borderRadius: 12, padding: '12px', marginBottom: 14,
        display: 'flex', justifyContent: 'space-around', textAlign: 'center',
      }}>
        <div><div style={{ fontSize: 20, fontWeight: 800, color: C.amarillo }}>{entregados}</div><div style={{ fontSize: 10, color: C.textoSuave }}>Entregados</div></div>
        <div><div style={{ fontSize: 20, fontWeight: 800, color: C.verde }}>{instalados}</div><div style={{ fontSize: 10, color: C.textoSuave }}>Instalados</div></div>
      </div>

      {miMaterial.length === 0 && <div style={{ textAlign: 'center', color: '#aaa', padding: 32, fontSize: 13 }}>No hay material registrado</div>}
      {miMaterial.map(m => (
        <div key={m.id} style={{ background: '#fff', borderRadius: 12, padding: '14px', marginBottom: 8, border: '1px solid #eee' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: C.principal }}>{m.descripcion}</div>
              <div style={{ fontSize: 11, color: '#888' }}>{m.tecnico} {'•'} {m.tipo} {'•'} x{m.cantidad}</div>
            </div>
            <div style={{ fontSize: 10, fontWeight: 700, padding: '4px 10px', borderRadius: 12, background: `${ec[m.estado]}22`, color: ec[m.estado], textTransform: 'capitalize', height: 'fit-content' }}>{m.estado}</div>
          </div>
          {m.estado !== 'devuelto' && (esSupervisor || m.estado === 'entregado') && (
            <div style={{ display: 'flex', gap: 6 }}>
              {m.estado === 'entregado' && <button onClick={() => cambiarEstado(m.id, 'instalado')} style={{
                flex: 1, padding: '7px', borderRadius: 8, border: 'none', cursor: 'pointer',
                background: `${C.verde}22`, color: C.verde, fontSize: 11, fontWeight: 600, fontFamily: PP,
              }}>{'✅'} Instalado</button>}
              {esSupervisor && <button onClick={() => cambiarEstado(m.id, 'devuelto')} style={{
                flex: 1, padding: '7px', borderRadius: 8, border: 'none', cursor: 'pointer',
                background: '#f5f5f5', color: '#888', fontSize: 11, fontWeight: 600, fontFamily: PP,
              }}>{'🔄'} Devuelto</button>}
            </div>
          )}
        </div>
      ))}

      {modal && (
        <ModalSheet onCerrar={() => setModal(false)} titulo="Entregar material/herramienta">
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Técnico</div>
            <input value={form.tecnico} onChange={e => setForm(p => ({ ...p, tecnico: e.target.value }))} placeholder="Nombre del técnico" style={inp} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Tipo</div>
            <div style={{ display: 'flex', gap: 6 }}>
              {['Material', 'Herramienta', 'Equipo Beep'].map(t => (
                <button key={t} onClick={() => setForm(p => ({ ...p, tipo: t }))} style={{
                  flex: 1, padding: '9px 6px', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: PP,
                  background: form.tipo === t ? C.acento : '#f0f0f0',
                  color: form.tipo === t ? C.principal : '#666', fontSize: 12, fontWeight: 600,
                }}>{t}</button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Descripción</div>
            <input value={form.descripcion} onChange={e => setForm(p => ({ ...p, descripcion: e.target.value }))} placeholder="Qué se entrega" style={inp} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Cantidad</div>
            <input type="number" min="1" value={form.cantidad} onChange={e => setForm(p => ({ ...p, cantidad: parseInt(e.target.value) || 1 }))} style={{ ...inp, width: 80 }} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={lbl}>Foto (opcional)</div>
            {form.foto ? <img src={form.foto} alt="" style={{ width: '100%', borderRadius: 10, maxHeight: 120, objectFit: 'cover' }} /> : (
              <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, background: '#fafafa', border: '2px dashed #ddd', borderRadius: 10, padding: 16, cursor: 'pointer', color: '#aaa', fontSize: 13 }}>
                {'📷'} Foto <input type="file" accept="image/*" capture="environment" onChange={handleFoto} style={{ display: 'none' }} />
              </label>
            )}
          </div>
          <button onClick={guardar} disabled={!form.tecnico.trim() || !form.descripcion.trim()} style={{
            ...btn, background: (form.tecnico.trim() && form.descripcion.trim()) ? C.acento : '#ddd',
            color: (form.tecnico.trim() && form.descripcion.trim()) ? C.principal : '#999',
          }}>{'📦'} Registrar entrega</button>
        </ModalSheet>
      )}
    </div>
  );
}

// ============================================
// TAB GASTOS
// ============================================
function TabGastos({ usuario, gastos, registrarGastoAPI, mostrarToast }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ tipo: 'Transporte', descripcion: '', monto: '', foto: '' });
  const tipos = ['Transporte', 'Comida', 'Material', 'Herramienta', 'Hospedaje', 'Otro'];
  const totalG = gastos.reduce((s, g) => s + (parseFloat(g.monto) || 0), 0);

  const guardar = async () => {
    if (!form.descripcion.trim() || !form.monto) return;
    await registrarGastoAPI({
      tipo: form.tipo, descripcion: form.descripcion,
      monto: parseFloat(form.monto) || 0, foto_url: form.foto,
      registrado_por: usuario?.nombre || 'Usuario', usuario_id: usuario?.id,
    });
    setModal(false); setForm({ tipo: 'Transporte', descripcion: '', monto: '', foto: '' });
    mostrarToast('Gasto registrado');
  };
  const handleFoto = (e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = ev => setForm(p => ({ ...p, foto: ev.target.result })); r.readAsDataURL(f); };

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>Gastos del evento</div>
          <div style={{ fontSize: 12, color: '#888' }}>Total: ${totalG.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
        </div>
        <button onClick={() => setModal(true)} style={{
          background: C.acento, border: 'none', color: C.principal, borderRadius: 10,
          padding: '10px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
        }}>{'➕'} Nuevo gasto</button>
      </div>

      {gastos.length === 0 && <div style={{ textAlign: 'center', color: '#aaa', padding: 32, fontSize: 13 }}>No hay gastos registrados</div>}
      {gastos.map(g => (
        <div key={g.id} style={{
          background: C.card, borderRadius: 12, padding: '14px', marginBottom: 8, color: '#fff',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600 }}>{g.descripcion}</div>
              <div style={{ fontSize: 11, color: C.textoSuave }}>{g.tipo} {'•'} {g.registradoPor}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 16, fontWeight: 800 }}>${(g.monto || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
              <div style={{
                fontSize: 9, fontWeight: 700, padding: '2px 8px', borderRadius: 8, marginTop: 2, display: 'inline-block',
                background: g.estado === 'aprobado' ? `${C.verde}33` : `${C.amarillo}33`,
                color: g.estado === 'aprobado' ? C.verde : C.amarillo,
              }}>{g.estado}</div>
            </div>
          </div>
          {g.foto && <img src={g.foto} alt="" style={{ width: '100%', borderRadius: 8, maxHeight: 80, objectFit: 'cover', marginTop: 8 }} />}
        </div>
      ))}

      {modal && (
        <ModalSheet onCerrar={() => setModal(false)} titulo="Nuevo gasto del evento">
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Tipo</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {tipos.map(t => (
                <button key={t} onClick={() => setForm(p => ({ ...p, tipo: t }))} style={{
                  padding: '7px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', fontFamily: PP,
                  background: form.tipo === t ? C.acento : '#f0f0f0',
                  color: form.tipo === t ? C.principal : '#666', fontSize: 12, fontWeight: 600,
                }}>{t}</button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Descripción</div>
            <input value={form.descripcion} onChange={e => setForm(p => ({ ...p, descripcion: e.target.value }))} placeholder="Descripción" style={inp} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Monto ($)</div>
            <input type="number" min="0" step="0.01" value={form.monto} onChange={e => setForm(p => ({ ...p, monto: e.target.value }))} placeholder="0.00" style={inp} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={lbl}>Comprobante (opcional)</div>
            {form.foto ? <img src={form.foto} alt="" style={{ width: '100%', borderRadius: 10, maxHeight: 120, objectFit: 'cover' }} /> : (
              <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, background: '#fafafa', border: '2px dashed #ddd', borderRadius: 10, padding: 16, cursor: 'pointer', color: '#aaa', fontSize: 13 }}>
                {'📷'} Foto <input type="file" accept="image/*" capture="environment" onChange={handleFoto} style={{ display: 'none' }} />
              </label>
            )}
          </div>
          <button onClick={guardar} disabled={!form.descripcion.trim() || !form.monto} style={{
            ...btn, background: (form.descripcion.trim() && form.monto) ? C.acento : '#ddd',
            color: (form.descripcion.trim() && form.monto) ? C.principal : '#999',
          }}>{'💰'} Registrar gasto</button>
        </ModalSheet>
      )}
    </div>
  );
}

// ============================================
// TAB INCIDENTES
// ============================================
function TabIncidentes({ incidentes, reportarIncidenteAPI, resolverIncidenteAPI, usuario, mostrarToast }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ zona: 1, tipo: 'nodos', descripcion: '', urgencia: 'media', foto: '' });

  const activos = incidentes.filter(i => i.estado === 'activo');
  const resueltos = incidentes.filter(i => i.estado === 'resuelto');

  const reportar = async () => {
    if (!form.descripcion.trim()) return;
    const tipoI = TIPOS_TRABAJO.find(t => t.id === form.tipo);
    await reportarIncidenteAPI({
      zona_id: form.zona, tipo: tipoI?.label || form.tipo,
      descripcion: form.descripcion, urgencia: form.urgencia,
      foto_url: form.foto, usuario_id: usuario?.id,
    });
    setModal(false); setForm({ zona: 1, tipo: 'nodos', descripcion: '', urgencia: 'media', foto: '' });
    mostrarToast('Incidente reportado');
  };

  const resolver = async (id) => {
    await resolverIncidenteAPI(id);
    mostrarToast('Incidente resuelto');
  };

  const handleFoto = (e) => { const f = e.target.files[0]; if (!f) return; const r = new FileReader(); r.onload = ev => setForm(p => ({ ...p, foto: ev.target.result })); r.readAsDataURL(f); };
  const urgCol = { alta: C.rojo, media: C.amarillo, baja: '#aaa' };

  return (
    <div style={{ padding: 16 }}>
      <div style={{ fontSize: 16, fontWeight: 700, color: C.principal, marginBottom: 14 }}>Incidentes</div>

      {activos.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.rojo, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>
            {'🚨'} Activos ({activos.length})
          </div>
          {activos.map(inc => (
            <div key={inc.id} className="pulso-borde" style={{
              background: '#fff', borderRadius: 12, padding: '14px', marginBottom: 8,
              border: `2px solid ${C.rojo}`,
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: C.principal }}>{inc.zonaEmoji} {inc.zona}</div>
                  <div style={{ fontSize: 11, color: '#888' }}>{inc.tipoEmoji} {inc.tipoInstalacion}</div>
                </div>
                <div style={{ fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 8, background: `${urgCol[inc.urgencia]}22`, color: urgCol[inc.urgencia], textTransform: 'uppercase', height: 'fit-content' }}>{inc.urgencia}</div>
              </div>
              <div style={{ fontSize: 13, color: '#333', marginBottom: 6 }}>{inc.descripcion}</div>
              {inc.foto && <img src={inc.foto} alt="" style={{ width: '100%', borderRadius: 8, maxHeight: 100, objectFit: 'cover', marginBottom: 6 }} />}
              <div style={{ fontSize: 10, color: '#888', marginBottom: 8 }}>Reportado {tiempoRel(inc.fecha)} por {inc.reportadoPor}</div>
              <button onClick={() => resolver(inc.id)} style={{
                width: '100%', padding: '10px', borderRadius: 10, border: 'none',
                background: C.verde, color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
              }}>{'✅'} Marcar resuelto</button>
            </div>
          ))}
        </div>
      )}

      {resueltos.length > 0 && (
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#aaa', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>Resueltos ({resueltos.length})</div>
          {resueltos.map(inc => (
            <div key={inc.id} style={{ background: '#f9f9f9', borderRadius: 12, padding: '12px', marginBottom: 6, border: '1px solid #eee' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#666' }}>{inc.zonaEmoji} {inc.zona} {'—'} {inc.tipoInstalacion}</div>
              <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>{inc.descripcion}</div>
              <div style={{ fontSize: 10, color: C.verde, marginTop: 4 }}>{'✅'} Resuelto por {inc.resueltoPor} {'•'} {inc.resueltoEn ? tiempoRel(inc.resueltoEn) : ''}</div>
            </div>
          ))}
        </div>
      )}

      {activos.length === 0 && resueltos.length === 0 && (
        <div style={{ textAlign: 'center', color: '#aaa', padding: 40, fontSize: 13 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>{'✅'}</div>Sin incidentes reportados
        </div>
      )}

      <button onClick={() => setModal(true)} style={{
        position: 'fixed', bottom: 70, right: 16, zIndex: 30,
        background: C.rojo, border: 'none', color: '#fff', borderRadius: 14,
        padding: '12px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
        boxShadow: '0 4px 12px rgba(255,23,68,0.3)', display: 'flex', alignItems: 'center', gap: 4,
      }}>{'🚨'} Reportar</button>

      {modal && (
        <ModalSheet onCerrar={() => setModal(false)} titulo="Reportar incidente">
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Zona</div>
            <select value={form.zona} onChange={e => setForm(p => ({ ...p, zona: parseInt(e.target.value) }))} style={{ ...inp, appearance: 'auto' }}>
              {ZONAS.map(z => <option key={z.id} value={z.id}>{z.emoji} {z.nombre}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Tipo de instalación</div>
            <select value={form.tipo} onChange={e => setForm(p => ({ ...p, tipo: e.target.value }))} style={{ ...inp, appearance: 'auto' }}>
              {TIPOS_TRABAJO.map(t => <option key={t.id} value={t.id}>{t.emoji} {t.label}</option>)}
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Descripción del problema *</div>
            <textarea value={form.descripcion} onChange={e => setForm(p => ({ ...p, descripcion: e.target.value }))} placeholder="Describe el problema..." rows={3} style={{ ...inp, resize: 'vertical' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={lbl}>Urgencia</div>
            <div style={{ display: 'flex', gap: 6 }}>
              {['alta', 'media', 'baja'].map(u => (
                <button key={u} onClick={() => setForm(p => ({ ...p, urgencia: u }))} style={{
                  flex: 1, padding: '9px', borderRadius: 8, border: form.urgencia === u ? `2px solid ${u === 'alta' ? C.rojo : '#999'}` : '2px solid #eee',
                  background: form.urgencia === u && u === 'alta' ? '#ffebee' : '#fff',
                  color: form.urgencia === u && u === 'alta' ? C.rojo : '#666',
                  fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: PP, textTransform: 'capitalize', minHeight: 40,
                }}>{u}</button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <div style={lbl}>Foto (recomendada)</div>
            {form.foto ? <img src={form.foto} alt="" style={{ width: '100%', borderRadius: 10, maxHeight: 120, objectFit: 'cover' }} /> : (
              <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, background: '#fafafa', border: '2px dashed #ddd', borderRadius: 10, padding: 16, cursor: 'pointer', color: '#aaa', fontSize: 13 }}>
                {'📷'} Foto <input type="file" accept="image/*" capture="environment" onChange={handleFoto} style={{ display: 'none' }} />
              </label>
            )}
          </div>
          <button onClick={reportar} disabled={!form.descripcion.trim()} style={{
            ...btn, background: form.descripcion.trim() ? C.rojo : '#ddd',
            color: form.descripcion.trim() ? '#fff' : '#999',
          }}>{'🚨'} Reportar incidente</button>
        </ModalSheet>
      )}
    </div>
  );
}

// ============================================
// COMPONENTES COMPARTIDOS
// ============================================
const lbl = { fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 4 };
const inp = {
  width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid #ddd',
  fontSize: 14, fontFamily: PP, boxSizing: 'border-box', outline: 'none',
};
const btn = {
  width: '100%', padding: 14, borderRadius: 12, border: 'none', fontSize: 14,
  fontWeight: 700, cursor: 'pointer', fontFamily: PP,
};

// ============================================
// CONFIG MODAL
// ============================================
function comprimirImagen(file) {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      const maxW = 400;
      const ratio = Math.min(maxW / img.width, maxW / img.height, 1);
      canvas.width = img.width * ratio;
      canvas.height = img.height * ratio;
      if (file.type === 'image/png') {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/png'));
      } else {
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/jpeg', 0.8));
      }
    };
    img.src = URL.createObjectURL(file);
  });
}

function ConfigModal({ config, onGuardar, onCerrar }) {
  const [logoUrl, setLogoUrl] = useState(config.logoUrl || '');
  const [nombreEvento, setNombreEvento] = useState(config.nombreEvento || 'Expo Alianza');
  const [anoEvento, setAnoEvento] = useState(config.anoEvento || '2026');

  const handleLogo = async (e) => {
    const f = e.target.files[0]; if (!f) return;
    const comprimido = await comprimirImagen(f);
    setLogoUrl(comprimido);
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100, fontFamily: PP }}>
      <div onClick={onCerrar} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)' }} />
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0, background: '#fff',
        borderRadius: '20px 20px 0 0', maxHeight: '85dvh', overflowY: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 4px' }}>
          <div style={{ width: 40, height: 4, borderRadius: 2, background: '#ddd' }} />
        </div>
        <div style={{ padding: '8px 20px 12px', borderBottom: '1px solid #eee' }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>{'⚙️'} Configuración del evento</div>
        </div>
        <div style={{ padding: '16px 20px 32px' }}>
          {/* Logo */}
          <div style={{ marginBottom: 20 }}>
            <div style={lbl}>Logo del evento</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <div style={{
                width: 72, height: 72, borderRadius: 14, background: C.card,
                border: `2px solid ${C.borde}`, display: 'flex', alignItems: 'center', justifyContent: 'center',
                overflow: 'hidden', flexShrink: 0,
              }}>
                {logoUrl
                  ? <img src={logoUrl} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  : <div style={{ fontSize: 28, color: C.textoSuave }}>{'🎪'}</div>
                }
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1 }}>
                <label style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                  background: C.acento, color: C.principal, borderRadius: 8,
                  padding: '8px 12px', cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: PP,
                }}>
                  {'📷'} Cambiar logo
                  <input type="file" accept="image/*" onChange={handleLogo} style={{ display: 'none' }} />
                </label>
                {logoUrl && (
                  <button onClick={() => setLogoUrl('')} style={{
                    background: '#f5f5f5', border: 'none', color: '#888', borderRadius: 8,
                    padding: '8px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: PP,
                  }}>{'🗑️'} Quitar logo</button>
                )}
              </div>
            </div>
          </div>

          {/* Nombre */}
          <div style={{ marginBottom: 16 }}>
            <div style={lbl}>Nombre del evento</div>
            <input value={nombreEvento} onChange={e => setNombreEvento(e.target.value)}
              placeholder="Ej: Expo Alianza, Beer Fest, Vinexpo" style={inp} />
          </div>

          {/* Año */}
          <div style={{ marginBottom: 20 }}>
            <div style={lbl}>Año</div>
            <input value={anoEvento} onChange={e => setAnoEvento(e.target.value)}
              placeholder="2026" style={{ ...inp, width: 100 }} />
          </div>

          {/* Guardar */}
          <button onClick={() => onGuardar({ logoUrl, nombreEvento, anoEvento })} style={{
            ...btn, background: C.acento, color: C.principal,
          }}>{'💾'} Guardar configuración</button>
        </div>
      </div>
    </div>
  );
}

function ModalSheet({ onCerrar, titulo, children }) {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100, fontFamily: PP }}>
      <div onClick={onCerrar} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)' }} />
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0, background: '#fff',
        borderRadius: '20px 20px 0 0', maxHeight: '85dvh', overflowY: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 4px' }}>
          <div style={{ width: 40, height: 4, borderRadius: 2, background: '#ddd' }} />
        </div>
        <div style={{ padding: '8px 20px 12px', borderBottom: '1px solid #eee' }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: C.principal }}>{titulo}</div>
        </div>
        <div style={{ padding: '16px 20px 32px' }}>{children}</div>
      </div>
    </div>
  );
}
